import './parking.scss';

export const ParkingLoader = () => {
  return (
    <div className="loader">
      <div className="loader__icon">
        <svg id="icon" version="1.1" x="0px" y="0px" viewBox="0 0 51.7 27.4">
          <g>
            <polygon
              className="yin"
              points="28.8,5.8 33.8,5.8 36.7,17.8 39.6,5.8 44.7,5.8 44.7,21.6 41.5,21.6 41.5,8.4 41.4,8.4 38.4,21.6 
        35,21.6 32,8.4 32,8.4
        32,21.6 28.8,21.6 		"
            ></polygon>
            <polygon
              className="yin"
              points="13.8,5.8 25.8,5.8 25.8,8.6 17.2,8.6 17.2,11.9 25.1,11.9 25.1,14.7 17.2,14.7 17.2,18.7 26.1,18.7 
        26.1,21.6 13.8,21.6 		"
            ></polygon>
            <rect
              x="7"
              y="5.8"
              className="yin"
              width="3.5"
              height="15.9"
            ></rect>
          </g>
        </svg>
      </div>

      <svg id="scene" version="1.1" x="0px" y="0px" viewBox="0 0 4000 2048">
        <g id="city">
          <g>
            <g>
              <rect
                x="2377.4"
                y="816.5"
                className="st1"
                width="224.8"
                height="430.4"
              />
              <rect
                x="2377.4"
                y="1198.3"
                className="st4"
                width="95.1"
                height="13.1"
              />
              <rect
                x="2489.8"
                y="1198.3"
                className="st3"
                width="33.4"
                height="13.1"
              />
              <rect
                x="2542.3"
                y="1198.3"
                className="st4"
                width="59.9"
                height="13.1"
              />
              <rect
                x="2433.4"
                y="1172.1"
                className="st4"
                width="39.1"
                height="13.1"
              />
              <rect
                x="2377.4"
                y="1172.1"
                className="st4"
                width="39.1"
                height="13.1"
              />
              <rect
                x="2394.4"
                y="1146"
                className="st4"
                width="112.1"
                height="13.1"
              />
              <rect
                x="2524"
                y="1146"
                className="st4"
                width="78.1"
                height="13.1"
              />
              <rect
                x="2377.4"
                y="1119.8"
                className="st4"
                width="95.1"
                height="13.1"
              />
              <rect
                x="2489.8"
                y="1119.8"
                className="st3"
                width="90.8"
                height="13.1"
              />
              <rect
                x="2443"
                y="1093.7"
                className="st4"
                width="80.1"
                height="13.1"
              />
              <rect
                x="2546.6"
                y="1093.7"
                className="st4"
                width="29.5"
                height="13.1"
              />
              <rect
                x="2394.4"
                y="1067.5"
                className="st3"
                width="78.1"
                height="13.1"
              />
              <rect
                x="2489.8"
                y="1067.5"
                className="st4"
                width="78.1"
                height="13.1"
              />
              <rect
                x="2541.7"
                y="1041.4"
                className="st4"
                width="60.5"
                height="13.1"
              />
              <rect
                x="2453"
                y="1041.4"
                className="st4"
                width="53.5"
                height="13.1"
              />
              <rect
                x="2408"
                y="1041.4"
                className="st4"
                width="26.7"
                height="13.1"
              />
              <rect
                x="2377.4"
                y="1015.2"
                className="st4"
                width="95.1"
                height="13.1"
              />
              <rect
                x="2503.2"
                y="1015.2"
                className="st3"
                width="78.1"
                height="13.1"
              />
              <rect
                x="2433.4"
                y="989"
                className="st4"
                width="39.1"
                height="13.1"
              />
              <rect
                x="2489.8"
                y="989"
                className="st4"
                width="33.4"
                height="13.1"
              />
              <rect
                x="2394.4"
                y="962.9"
                className="st4"
                width="39.1"
                height="13.1"
              />
              <rect
                x="2489.8"
                y="962.9"
                className="st4"
                width="78.1"
                height="13.1"
              />
              <rect
                x="2450.4"
                y="936.7"
                className="st4"
                width="56"
                height="13.1"
              />
              <rect
                x="2546.6"
                y="936.7"
                className="st4"
                width="56"
                height="13.1"
              />
              <rect
                x="2394.4"
                y="910.6"
                className="st3"
                width="78.1"
                height="13.1"
              />
              <rect
                x="2489.8"
                y="910.6"
                className="st4"
                width="78.1"
                height="13.1"
              />
              <rect
                x="2444"
                y="884.4"
                className="st4"
                width="78.1"
                height="13.1"
              />
              <rect
                x="2394.4"
                y="858.3"
                className="st4"
                width="78.1"
                height="13.1"
              />
              <rect
                x="2522.3"
                y="858.3"
                className="st3"
                width="79.8"
                height="13.1"
              />
              <rect
                x="2377.4"
                y="832.1"
                className="st4"
                width="225.3"
                height="13.1"
              />
              <polygon
                className="st5"
                points="2377.4,1246.9 2602.2,1246.9 2377.4,816.5 			"
              />
            </g>
            <g>
              <rect
                x="1670"
                y="997.6"
                className="st1"
                width="148.4"
                height="249.2"
              />
              <rect
                x="1670"
                y="1218.7"
                className="st4"
                width="62.8"
                height="7.6"
              />
              <rect
                x="1744.2"
                y="1218.7"
                className="st3"
                width="22"
                height="7.6"
              />
              <rect
                x="1778.9"
                y="1218.7"
                className="st4"
                width="39.5"
                height="7.6"
              />
              <rect
                x="1707.1"
                y="1203.6"
                className="st4"
                width="25.8"
                height="7.6"
              />
              <rect
                x="1670"
                y="1203.6"
                className="st4"
                width="25.8"
                height="7.6"
              />
              <rect
                x="1681.3"
                y="1188.4"
                className="st4"
                width="74"
                height="7.6"
              />
              <rect
                x="1766.8"
                y="1188.4"
                className="st4"
                width="51.6"
                height="7.6"
              />
              <rect
                x="1670"
                y="1173.3"
                className="st4"
                width="62.8"
                height="7.6"
              />
              <rect
                x="1744.2"
                y="1173.3"
                className="st3"
                width="59.9"
                height="7.6"
              />
              <rect
                x="1713.4"
                y="1158.2"
                className="st4"
                width="52.9"
                height="7.6"
              />
              <rect
                x="1781.7"
                y="1158.2"
                className="st4"
                width="19.5"
                height="7.6"
              />
              <rect
                x="1681.3"
                y="1143"
                className="st3"
                width="51.6"
                height="7.6"
              />
              <rect
                x="1744.2"
                y="1143"
                className="st4"
                width="51.6"
                height="7.6"
              />
              <rect
                x="1778.5"
                y="1127.9"
                className="st4"
                width="39.9"
                height="7.6"
              />
              <rect
                x="1719.9"
                y="1127.9"
                className="st4"
                width="35.3"
                height="7.6"
              />
              <rect
                x="1690.2"
                y="1127.9"
                className="st4"
                width="17.6"
                height="7.6"
              />
              <rect
                x="1670"
                y="1112.7"
                className="st4"
                width="62.8"
                height="7.6"
              />
              <rect
                x="1753.1"
                y="1112.7"
                className="st3"
                width="51.6"
                height="7.6"
              />
              <rect
                x="1707.1"
                y="1097.6"
                className="st4"
                width="25.8"
                height="7.6"
              />
              <rect
                x="1744.2"
                y="1097.6"
                className="st4"
                width="22"
                height="7.6"
              />
              <rect
                x="1681.3"
                y="1082.4"
                className="st4"
                width="25.8"
                height="7.6"
              />
              <rect
                x="1744.2"
                y="1082.4"
                className="st4"
                width="51.6"
                height="7.6"
              />
              <rect
                x="1718.3"
                y="1067.3"
                className="st4"
                width="37"
                height="7.6"
              />
              <rect
                x="1781.7"
                y="1067.3"
                className="st4"
                width="37"
                height="7.6"
              />
              <rect
                x="1681.3"
                y="1052.1"
                className="st3"
                width="51.6"
                height="7.6"
              />
              <rect
                x="1744.2"
                y="1052.1"
                className="st4"
                width="51.6"
                height="7.6"
              />
              <rect
                x="1714"
                y="1037"
                className="st4"
                width="51.6"
                height="7.6"
              />
              <rect
                x="1681.3"
                y="1021.8"
                className="st4"
                width="51.6"
                height="7.6"
              />
              <rect
                x="1765.7"
                y="1021.8"
                className="st3"
                width="52.7"
                height="7.6"
              />
              <rect
                x="1670"
                y="1006.7"
                className="st4"
                width="148.7"
                height="7.6"
              />
              <polygon
                className="st5"
                points="1670,1246.9 1818.4,1246.9 1670,997.6 			"
              />
            </g>
            <g>
              <rect
                x="2261.7"
                y="972.1"
                className="st1"
                width="163.2"
                height="274.8"
              />
              <rect
                x="2261.7"
                y="1215.9"
                className="st4"
                width="69"
                height="8.4"
              />
              <rect
                x="2343.3"
                y="1215.9"
                className="st3"
                width="24.2"
                height="8.4"
              />
              <rect
                x="2381.4"
                y="1215.9"
                className="st4"
                width="43.5"
                height="8.4"
              />
              <rect
                x="2302.4"
                y="1199.2"
                className="st4"
                width="28.3"
                height="8.3"
              />
              <rect
                x="2261.7"
                y="1199.2"
                className="st4"
                width="28.4"
                height="8.3"
              />
              <rect
                x="2274.1"
                y="1182.5"
                className="st4"
                width="81.3"
                height="8.3"
              />
              <rect
                x="2368.2"
                y="1182.5"
                className="st4"
                width="56.7"
                height="8.3"
              />
              <rect
                x="2261.7"
                y="1165.8"
                className="st4"
                width="69"
                height="8.4"
              />
              <rect
                x="2343.3"
                y="1165.8"
                className="st3"
                width="65.9"
                height="8.4"
              />
              <rect
                x="2309.4"
                y="1149.1"
                className="st4"
                width="58.1"
                height="8.3"
              />
              <rect
                x="2384.6"
                y="1149.1"
                className="st4"
                width="21.4"
                height="8.3"
              />
              <rect
                x="2274.1"
                y="1132.4"
                className="st3"
                width="56.7"
                height="8.4"
              />
              <rect
                x="2343.3"
                y="1132.4"
                className="st4"
                width="56.7"
                height="8.4"
              />
              <rect
                x="2381"
                y="1115.7"
                className="st4"
                width="43.9"
                height="8.4"
              />
              <rect
                x="2316.6"
                y="1115.7"
                className="st4"
                width="38.8"
                height="8.4"
              />
              <rect
                x="2283.9"
                y="1115.7"
                className="st4"
                width="19.4"
                height="8.4"
              />
              <rect
                x="2261.7"
                y="1099"
                className="st4"
                width="69"
                height="8.4"
              />
              <rect
                x="2353.1"
                y="1099"
                className="st3"
                width="56.7"
                height="8.4"
              />
              <rect
                x="2302.4"
                y="1082.3"
                className="st4"
                width="28.3"
                height="8.4"
              />
              <rect
                x="2343.3"
                y="1082.3"
                className="st4"
                width="24.2"
                height="8.4"
              />
              <rect
                x="2274.1"
                y="1065.6"
                className="st4"
                width="28.4"
                height="8.4"
              />
              <rect
                x="2343.3"
                y="1065.6"
                className="st4"
                width="56.7"
                height="8.4"
              />
              <rect
                x="2314.7"
                y="1048.9"
                className="st4"
                width="40.7"
                height="8.4"
              />
              <rect
                x="2384.6"
                y="1048.9"
                className="st4"
                width="40.7"
                height="8.4"
              />
              <rect
                x="2274.1"
                y="1032.2"
                className="st3"
                width="56.7"
                height="8.4"
              />
              <rect
                x="2343.3"
                y="1032.2"
                className="st4"
                width="56.7"
                height="8.4"
              />
              <rect
                x="2310.1"
                y="1015.5"
                className="st4"
                width="56.7"
                height="8.4"
              />
              <rect
                x="2274.1"
                y="998.8"
                className="st4"
                width="56.7"
                height="8.3"
              />
              <rect
                x="2366.9"
                y="998.8"
                className="st3"
                width="57.9"
                height="8.3"
              />
              <rect
                x="2261.7"
                y="982.1"
                className="st4"
                width="163.5"
                height="8.4"
              />
              <polygon
                className="st5"
                points="2261.7,1246.9 2424.9,1246.9 2261.7,972.1 			"
              />
            </g>
            <g>
              <rect
                x="1470.5"
                y="927.9"
                className="st1"
                width="160.5"
                height="319"
              />
              <rect
                x="1470.5"
                y="1210.9"
                className="st4"
                width="67.9"
                height="9.7"
              />
              <rect
                x="1550.7"
                y="1210.9"
                className="st3"
                width="23.8"
                height="9.7"
              />
              <rect
                x="1588.2"
                y="1210.9"
                className="st4"
                width="42.8"
                height="9.7"
              />
              <rect
                x="1510.5"
                y="1191.5"
                className="st4"
                width="27.9"
                height="9.7"
              />
              <rect
                x="1470.5"
                y="1191.5"
                className="st4"
                width="27.9"
                height="9.7"
              />
              <rect
                x="1482.7"
                y="1172.1"
                className="st4"
                width="80"
                height="9.7"
              />
              <rect
                x="1575.2"
                y="1172.1"
                className="st4"
                width="55.8"
                height="9.7"
              />
              <rect
                x="1470.5"
                y="1152.7"
                className="st4"
                width="67.9"
                height="9.7"
              />
              <rect
                x="1550.7"
                y="1152.7"
                className="st3"
                width="64.8"
                height="9.7"
              />
              <rect
                x="1517.4"
                y="1133.3"
                className="st4"
                width="57.2"
                height="9.7"
              />
              <rect
                x="1591.3"
                y="1133.3"
                className="st4"
                width="21.1"
                height="9.7"
              />
              <rect
                x="1482.7"
                y="1114"
                className="st3"
                width="55.8"
                height="9.7"
              />
              <rect
                x="1550.7"
                y="1114"
                className="st4"
                width="55.8"
                height="9.7"
              />
              <rect
                x="1587.8"
                y="1094.6"
                className="st4"
                width="43.2"
                height="9.7"
              />
              <rect
                x="1524.5"
                y="1094.6"
                className="st4"
                width="38.2"
                height="9.7"
              />
              <rect
                x="1492.3"
                y="1094.6"
                className="st4"
                width="19.1"
                height="9.7"
              />
              <rect
                x="1470.5"
                y="1075.2"
                className="st4"
                width="67.9"
                height="9.7"
              />
              <rect
                x="1560.3"
                y="1075.2"
                className="st3"
                width="55.8"
                height="9.7"
              />
              <rect
                x="1510.5"
                y="1055.8"
                className="st4"
                width="27.9"
                height="9.7"
              />
              <rect
                x="1550.7"
                y="1055.8"
                className="st4"
                width="23.8"
                height="9.7"
              />
              <rect
                x="1482.7"
                y="1036.4"
                className="st4"
                width="27.9"
                height="9.7"
              />
              <rect
                x="1550.7"
                y="1036.4"
                className="st4"
                width="55.8"
                height="9.7"
              />
              <rect
                x="1522.7"
                y="1017"
                className="st4"
                width="40"
                height="9.7"
              />
              <rect
                x="1591.3"
                y="1017"
                className="st4"
                width="40"
                height="9.7"
              />
              <rect
                x="1482.7"
                y="997.6"
                className="st3"
                width="55.8"
                height="9.7"
              />
              <rect
                x="1550.7"
                y="997.6"
                className="st4"
                width="55.8"
                height="9.7"
              />
              <rect
                x="1518.1"
                y="978.2"
                className="st4"
                width="55.8"
                height="9.7"
              />
              <rect
                x="1482.7"
                y="958.9"
                className="st4"
                width="55.8"
                height="9.7"
              />
              <rect
                x="1574"
                y="958.9"
                className="st3"
                width="57"
                height="9.7"
              />
              <rect
                x="1470.5"
                y="939.5"
                className="st4"
                width="160.8"
                height="9.7"
              />
              <polygon
                className="st5"
                points="1470.5,1246.9 1631,1246.9 1470.5,927.9 			"
              />
            </g>
            <g>
              <rect
                x="1777.9"
                y="879.6"
                className="st1"
                width="184.8"
                height="367.2"
              />
              <rect
                x="1777.9"
                y="909.9"
                className="st4"
                width="78.2"
                height="11.2"
              />
              <rect
                x="1870.3"
                y="909.9"
                className="st3"
                width="27.4"
                height="11.2"
              />
              <rect
                x="1913.4"
                y="909.9"
                className="st4"
                width="49.2"
                height="11.2"
              />
              <rect
                x="1824"
                y="932.3"
                className="st4"
                width="32.1"
                height="11.2"
              />
              <rect
                x="1777.9"
                y="932.3"
                className="st4"
                width="32.1"
                height="11.2"
              />
              <rect
                x="1791.9"
                y="954.6"
                className="st4"
                width="92.1"
                height="11.2"
              />
              <rect
                x="1898.4"
                y="954.6"
                className="st4"
                width="64.2"
                height="11.2"
              />
              <rect
                x="1777.9"
                y="976.9"
                className="st4"
                width="78.2"
                height="11.2"
              />
              <rect
                x="1870.3"
                y="976.9"
                className="st3"
                width="74.6"
                height="11.2"
              />
              <rect
                x="1831.8"
                y="999.2"
                className="st4"
                width="65.9"
                height="11.2"
              />
              <rect
                x="1917"
                y="999.2"
                className="st4"
                width="24.3"
                height="11.2"
              />
              <rect
                x="1791.9"
                y="1021.5"
                className="st3"
                width="64.2"
                height="11.2"
              />
              <rect
                x="1870.3"
                y="1021.5"
                className="st4"
                width="64.2"
                height="11.2"
              />
              <rect
                x="1913"
                y="1043.9"
                className="st4"
                width="49.7"
                height="11.2"
              />
              <rect
                x="1840"
                y="1043.9"
                className="st4"
                width="44"
                height="11.2"
              />
              <rect
                x="1803"
                y="1043.9"
                className="st4"
                width="22"
                height="11.2"
              />
              <rect
                x="1777.9"
                y="1066.2"
                className="st4"
                width="78.2"
                height="11.2"
              />
              <rect
                x="1881.3"
                y="1066.2"
                className="st3"
                width="64.2"
                height="11.2"
              />
              <rect
                x="1824"
                y="1088.5"
                className="st4"
                width="32.1"
                height="11.2"
              />
              <rect
                x="1870.3"
                y="1088.5"
                className="st4"
                width="27.4"
                height="11.2"
              />
              <rect
                x="1791.9"
                y="1110.8"
                className="st4"
                width="32.1"
                height="11.2"
              />
              <rect
                x="1870.3"
                y="1110.8"
                className="st4"
                width="64.2"
                height="11.2"
              />
              <rect
                x="1837.9"
                y="1133.1"
                className="st4"
                width="46.1"
                height="11.2"
              />
              <rect
                x="1917"
                y="1133.1"
                className="st4"
                width="46.1"
                height="11.2"
              />
              <rect
                x="1791.9"
                y="1155.5"
                className="st3"
                width="64.2"
                height="11.2"
              />
              <rect
                x="1870.3"
                y="1155.5"
                className="st4"
                width="64.2"
                height="11.2"
              />
              <rect
                x="1832.7"
                y="1177.8"
                className="st4"
                width="64.2"
                height="11.2"
              />
              <rect
                x="1791.9"
                y="1200.1"
                className="st4"
                width="64.2"
                height="11.2"
              />
              <rect
                x="1897"
                y="1200.1"
                className="st3"
                width="65.6"
                height="11.2"
              />
              <polygon
                className="st5"
                points="1777.9,1246.9 1962.7,1246.9 1777.9,879.6 			"
              />
            </g>
            <g>
              <rect
                x="2026.3"
                y="716.8"
                className="st1"
                width="187.3"
                height="530.1"
              />
              <rect
                x="2026.3"
                y="1187"
                className="st4"
                width="79.3"
                height="16.1"
              />
              <rect
                x="2119.9"
                y="1187"
                className="st3"
                width="27.8"
                height="16.1"
              />
              <rect
                x="2163.7"
                y="1187"
                className="st4"
                width="49.9"
                height="16.1"
              />
              <rect
                x="2073"
                y="1154.8"
                className="st4"
                width="32.5"
                height="16.1"
              />
              <rect
                x="2026.3"
                y="1154.8"
                className="st4"
                width="32.5"
                height="16.1"
              />
              <rect
                x="2040.5"
                y="1122.6"
                className="st4"
                width="93.4"
                height="16.1"
              />
              <rect
                x="2148.5"
                y="1122.6"
                className="st4"
                width="65.1"
                height="16.1"
              />
              <rect
                x="2026.3"
                y="1090.4"
                className="st4"
                width="79.3"
                height="16.1"
              />
              <rect
                x="2119.9"
                y="1090.4"
                className="st3"
                width="75.6"
                height="16.1"
              />
              <rect
                x="2081"
                y="1058.2"
                className="st4"
                width="66.7"
                height="16.1"
              />
              <rect
                x="2167.3"
                y="1058.2"
                className="st4"
                width="24.6"
                height="16.1"
              />
              <rect
                x="2040.5"
                y="1025.9"
                className="st3"
                width="65.1"
                height="16.1"
              />
              <rect
                x="2119.9"
                y="1025.9"
                className="st4"
                width="65.1"
                height="16.1"
              />
              <rect
                x="2163.2"
                y="993.7"
                className="st4"
                width="50.4"
                height="16.1"
              />
              <rect
                x="2089.3"
                y="993.7"
                className="st4"
                width="44.5"
                height="16.1"
              />
              <rect
                x="2051.8"
                y="993.7"
                className="st4"
                width="22.3"
                height="16.1"
              />
              <rect
                x="2026.3"
                y="961.5"
                className="st4"
                width="79.3"
                height="16.1"
              />
              <rect
                x="2131.1"
                y="961.5"
                className="st3"
                width="65.1"
                height="16.1"
              />
              <rect
                x="2073"
                y="929.3"
                className="st4"
                width="32.5"
                height="16.1"
              />
              <rect
                x="2119.9"
                y="929.3"
                className="st4"
                width="27.8"
                height="16.1"
              />
              <rect
                x="2040.5"
                y="897.1"
                className="st4"
                width="32.5"
                height="16.1"
              />
              <rect
                x="2119.9"
                y="897.1"
                className="st4"
                width="65.1"
                height="16.1"
              />
              <rect
                x="2087.1"
                y="864.8"
                className="st4"
                width="46.7"
                height="16.1"
              />
              <rect
                x="2167.3"
                y="864.8"
                className="st4"
                width="46.7"
                height="16.1"
              />
              <rect
                x="2040.5"
                y="832.6"
                className="st3"
                width="65.1"
                height="16.1"
              />
              <rect
                x="2119.9"
                y="832.6"
                className="st4"
                width="65.1"
                height="16.1"
              />
              <rect
                x="2081.8"
                y="800.4"
                className="st4"
                width="65.1"
                height="16.1"
              />
              <rect
                x="2040.5"
                y="768.2"
                className="st4"
                width="65.1"
                height="16.1"
              />
              <rect
                x="2147.1"
                y="768.2"
                className="st3"
                width="66.5"
                height="16.1"
              />
              <rect
                x="2026.3"
                y="736"
                className="st4"
                width="187.7"
                height="16.1"
              />
              <polygon
                className="st5"
                points="2026.3,1246.9 2213.6,1246.9 2026.3,716.8 			"
              />
            </g>
            <g>
              <rect
                x="1277.8"
                y="1055.9"
                className="st1"
                width="96.1"
                height="191"
              />
              <rect
                x="1277.8"
                y="1071.7"
                className="st4"
                width="40.7"
                height="5.8"
              />
              <rect
                x="1325.9"
                y="1071.7"
                className="st3"
                width="14.3"
                height="5.8"
              />
              <rect
                x="1348.3"
                y="1071.7"
                className="st4"
                width="25.6"
                height="5.8"
              />
              <rect
                x="1301.8"
                y="1083.3"
                className="st4"
                width="16.7"
                height="5.8"
              />
              <rect
                x="1277.8"
                y="1083.3"
                className="st4"
                width="16.7"
                height="5.8"
              />
              <rect
                x="1285.1"
                y="1094.9"
                className="st4"
                width="47.9"
                height="5.8"
              />
              <rect
                x="1340.5"
                y="1094.9"
                className="st4"
                width="33.4"
                height="5.8"
              />
              <rect
                x="1277.8"
                y="1106.5"
                className="st4"
                width="40.7"
                height="5.8"
              />
              <rect
                x="1325.9"
                y="1106.5"
                className="st3"
                width="38.8"
                height="5.8"
              />
              <rect
                x="1305.9"
                y="1118.1"
                className="st4"
                width="34.2"
                height="5.8"
              />
              <rect
                x="1350.2"
                y="1118.1"
                className="st4"
                width="12.6"
                height="5.8"
              />
              <rect
                x="1285.1"
                y="1129.7"
                className="st3"
                width="33.4"
                height="5.8"
              />
              <rect
                x="1325.9"
                y="1129.7"
                className="st4"
                width="33.4"
                height="5.8"
              />
              <rect
                x="1348.1"
                y="1141.3"
                className="st4"
                width="25.8"
                height="5.8"
              />
              <rect
                x="1310.1"
                y="1141.3"
                className="st4"
                width="22.9"
                height="5.8"
              />
              <rect
                x="1290.9"
                y="1141.3"
                className="st4"
                width="11.4"
                height="5.8"
              />
              <rect
                x="1277.8"
                y="1152.9"
                className="st4"
                width="40.7"
                height="5.8"
              />
              <rect
                x="1331.6"
                y="1152.9"
                className="st3"
                width="33.4"
                height="5.8"
              />
              <rect
                x="1301.8"
                y="1164.5"
                className="st4"
                width="16.7"
                height="5.8"
              />
              <rect
                x="1325.9"
                y="1164.5"
                className="st4"
                width="14.3"
                height="5.8"
              />
              <rect
                x="1285.1"
                y="1176.1"
                className="st4"
                width="16.7"
                height="5.8"
              />
              <rect
                x="1325.9"
                y="1176.1"
                className="st4"
                width="33.4"
                height="5.8"
              />
              <rect
                x="1309.1"
                y="1187.7"
                className="st4"
                width="23.9"
                height="5.8"
              />
              <rect
                x="1350.2"
                y="1187.7"
                className="st4"
                width="24"
                height="5.8"
              />
              <rect
                x="1285.1"
                y="1199.3"
                className="st3"
                width="33.4"
                height="5.8"
              />
              <rect
                x="1325.9"
                y="1199.3"
                className="st4"
                width="33.4"
                height="5.8"
              />
              <rect
                x="1306.3"
                y="1211"
                className="st4"
                width="33.4"
                height="5.8"
              />
              <rect
                x="1285.1"
                y="1222.6"
                className="st4"
                width="33.4"
                height="5.8"
              />
              <rect
                x="1339.8"
                y="1222.6"
                className="st3"
                width="34.1"
                height="5.8"
              />
              <polygon
                className="st5"
                points="1277.8,1246.9 1373.9,1246.9 1277.8,1055.9 			"
              />
            </g>
            <g>
              <rect
                x="2597.6"
                y="924.7"
                className="st1"
                width="162.1"
                height="322.2"
              />
              <rect
                x="2597.6"
                y="1210.5"
                className="st4"
                width="68.6"
                height="9.8"
              />
              <rect
                x="2678.7"
                y="1210.5"
                className="st3"
                width="24.1"
                height="9.8"
              />
              <rect
                x="2716.5"
                y="1210.5"
                className="st4"
                width="43.2"
                height="9.8"
              />
              <rect
                x="2638"
                y="1190.9"
                className="st4"
                width="28.2"
                height="9.8"
              />
              <rect
                x="2597.6"
                y="1190.9"
                className="st4"
                width="28.2"
                height="9.8"
              />
              <rect
                x="2609.9"
                y="1171.4"
                className="st4"
                width="80.8"
                height="9.8"
              />
              <rect
                x="2703.4"
                y="1171.4"
                className="st4"
                width="56.3"
                height="9.8"
              />
              <rect
                x="2597.6"
                y="1151.8"
                className="st4"
                width="68.6"
                height="9.8"
              />
              <rect
                x="2678.7"
                y="1151.8"
                className="st3"
                width="65.4"
                height="9.8"
              />
              <rect
                x="2644.9"
                y="1132.2"
                className="st4"
                width="57.8"
                height="9.8"
              />
              <rect
                x="2719.6"
                y="1132.2"
                className="st4"
                width="21.3"
                height="9.8"
              />
              <rect
                x="2609.9"
                y="1112.6"
                className="st3"
                width="56.3"
                height="9.8"
              />
              <rect
                x="2678.7"
                y="1112.6"
                className="st4"
                width="56.3"
                height="9.8"
              />
              <rect
                x="2716.1"
                y="1093"
                className="st4"
                width="43.6"
                height="9.8"
              />
              <rect
                x="2652.1"
                y="1093"
                className="st4"
                width="38.6"
                height="9.8"
              />
              <rect
                x="2619.7"
                y="1093"
                className="st4"
                width="19.3"
                height="9.8"
              />
              <rect
                x="2597.6"
                y="1073.5"
                className="st4"
                width="68.6"
                height="9.8"
              />
              <rect
                x="2688.3"
                y="1073.5"
                className="st3"
                width="56.3"
                height="9.8"
              />
              <rect
                x="2638"
                y="1053.9"
                className="st4"
                width="28.2"
                height="9.8"
              />
              <rect
                x="2678.7"
                y="1053.9"
                className="st4"
                width="24.1"
                height="9.8"
              />
              <rect
                x="2609.9"
                y="1034.3"
                className="st4"
                width="28.2"
                height="9.8"
              />
              <rect
                x="2678.7"
                y="1034.3"
                className="st4"
                width="56.3"
                height="9.8"
              />
              <rect
                x="2650.3"
                y="1014.7"
                className="st4"
                width="40.4"
                height="9.8"
              />
              <rect
                x="2719.6"
                y="1014.7"
                className="st4"
                width="40.4"
                height="9.8"
              />
              <rect
                x="2609.9"
                y="995.1"
                className="st3"
                width="56.3"
                height="9.8"
              />
              <rect
                x="2678.7"
                y="995.1"
                className="st4"
                width="56.3"
                height="9.8"
              />
              <rect
                x="2645.7"
                y="975.6"
                className="st4"
                width="56.3"
                height="9.8"
              />
              <rect
                x="2609.9"
                y="956"
                className="st4"
                width="56.3"
                height="9.8"
              />
              <rect
                x="2702.1"
                y="956"
                className="st3"
                width="57.6"
                height="9.8"
              />
              <rect
                x="2597.6"
                y="936.4"
                className="st4"
                width="162.4"
                height="9.8"
              />
              <polygon
                className="st5"
                points="2597.6,1246.9 2759.7,1246.9 2597.6,924.7 			"
              />
            </g>
          </g>
          <path
            className="st1"
            d="M3896.3,1216.2l103.7,48.4H0l276.3-28.1l291.9-37.7l143.1-14.5c0,0,126.3-2,168.4,8.4
c42.1,10.3,247.5-32.6,247.5-32.6s380.1,9.5,411.7,7.5c31.6-2.1,276.4-23.1,393.9-16.7c117.4,6.4,241-5.1,343.4,4.8
c102.4,9.9,327.2-6.2,400.1-12.7c72.9-6.5,428.1,23,464.1,28.6c36.1,5.6,173-27.9,248.8-15.9
C3465,1167.6,3896.3,1216.2,3896.3,1216.2z"
          />
          <path
            className="st0"
            d="M119.3,1255.9L0,1265.4h4000l-277.5-38.5l-290.6,4.5l-143.1-7.5c0,0-126.3-1-168.4,4.3
c-42.1,5.3-457.7-3.5-457.7-3.5s-170-8.4-201.6-9.5c-31.6-1.1-276.4-12-393.9-8.6c-117.4,3.3-241-2.6-343.4,2.5
c-102.4,5.1-327.2-3.2-400.1-6.6c-72.9-3.4-428.1,11.9-464.1,14.8c-36.1,2.9-259.2,13.7-335,19.9
C448.7,1243.3,119.3,1255.9,119.3,1255.9z"
          />
        </g>
        <g id="trees">
          <g>
            <g>
              <g>
                <defs>
                  <path
                    id="SVGID_2_"
                    d="M3608.5,1270.7c-25.4-4-45.3-31.9-51.1-65c-5.8-33.1-3.1-64.2,16.7-48.1c19.8,16,28-8,22.4-26.9
        c-15.2-51.3,5-140.6,27.7-112.7c22.7,27.9,0.1,21.4,28.2-10.4c28.1-31.8,87.3-40.8,62.1,10c-25.2,50.8-64.5,92.4-39.1,79.7
        s64.9-9.1,39.6,20.2c-25.3,29.3-64.6,68.6-44.8,68s90.2-24.2,34,27.5C3648,1264.7,3608.5,1270.7,3608.5,1270.7z"
                  />
                </defs>
              </g>
              <g>
                <path
                  className="st3"
                  d="M3689.3,1006.4c-12.8,19.6-24.2,40.1-34.5,61.1c-10.3,21-19.3,42.6-26.2,64.9l-2.5,8.4l-0.6,2.1l-0.5,2.1
      l-1.1,4.2l-2.1,8.5l-1.6,8.6c-0.5,2.9-1.1,5.7-1.6,8.6l-1.3,8.7c-0.8,5.8-1.5,11.6-2.1,17.4c-1.3,11.6-2.2,23.2-2.8,34.9
      c-0.6,11.6-0.9,23.3-0.5,34.8l-6.8,0.2c-0.1-12,0.5-23.6,1.4-35.4c0.9-11.7,2.1-23.4,3.7-35.1c0.8-5.8,1.7-11.6,2.6-17.4
      l1.5-8.7c0.5-2.9,1.2-5.8,1.8-8.7l1.9-8.7l2.3-8.5l1.2-4.3l0.6-2.1l0.7-2.1l2.7-8.4c7.5-22.3,17.1-43.8,27.9-64.6
      C3664.2,1046,3676.1,1025.7,3689.3,1006.4z"
                />
                <path
                  className="st3"
                  d="M3629.4,1119.4c0.1-5.9-0.3-11.9-0.9-17.8c-0.7-5.9-1.6-11.9-2.7-17.7c-1.2-5.9-2.5-11.7-4.1-17.5
      c-1.6-5.8-3.3-11.5-5.4-17.2c2.3,5.5,4.3,11.2,6.2,17c1.8,5.7,3.4,11.5,4.9,17.4c1.4,5.9,2.6,11.8,3.5,17.8
      c0.9,6,1.6,12,1.8,18.1L3629.4,1119.4z"
                />
                <path
                  className="st3"
                  d="M3606.2,1233.8c-0.7-1.6-1.8-3.5-2.8-5.1c-1.1-1.7-2.2-3.4-3.4-5c-2.4-3.2-5-6.4-7.9-9.3
      c-2.9-2.9-5.9-5.6-9.3-8.1c-1.6-1.3-3.4-2.4-5.1-3.6c-1.7-1.1-3.5-2.1-5.3-3.2c1.9,0.9,3.8,1.7,5.6,2.6c1.8,1,3.7,1.9,5.5,3
      c3.6,2.1,7,4.6,10.3,7.2c3.3,2.6,6.3,5.6,9.2,8.7c1.4,1.6,2.8,3.2,4.1,4.9c1.3,1.7,2.5,3.4,3.7,5.4L3606.2,1233.8z"
                />
                <path
                  className="st3"
                  d="M3609.4,1206.9c3.5-3.4,7.1-6.6,10.8-9.7c3.7-3.1,7.4-6.2,11.2-9.1c3.8-2.9,7.7-5.7,11.7-8.4
      c4-2.6,8.1-5.1,12.4-7.3c-4,2.6-7.9,5.4-11.6,8.4c-3.7,3-7.3,6.1-10.8,9.4c-3.5,3.2-6.9,6.6-10.2,10c-3.3,3.4-6.6,6.9-9.7,10.4
      L3609.4,1206.9z"
                />
                <path
                  className="st3"
                  d="M3618.4,1160c4.4-4.3,8.9-8.3,13.6-12.1c4.7-3.8,9.5-7.4,14.5-10.8c5-3.4,10.2-6.4,15.5-9.2
      c5.4-2.7,10.9-5,16.6-6.9c-5.6,2.2-11,4.8-16.1,7.8c-5.1,3.1-10.1,6.4-14.8,10c-4.7,3.6-9.3,7.5-13.7,11.5
      c-4.4,4-8.6,8.2-12.5,12.6L3618.4,1160z"
                />
              </g>
            </g>
            <g>
              <g>
                <defs>
                  <path
                    id="SVGID_4_"
                    d="M3594,1294.7c21.9-4.6,39.1-29.6,44.2-58.4c5.1-28.8,2.9-55.5-14.3-40.7c-17.1,14.7-24.7-5.7-19.3-22.1
        c13.8-42.1-4-121-23.6-95.9c-19.6,25.1-16.7,5.3-24.3-7.7c-18-30.7-75.2-31.2-53.6,11.4c21.6,42.6,55.4,76.7,33.5,67
        s-55.9-4.9-34.2,19.2c21.7,24.1,55.5,56.2,38.5,56.6c-17,0.4-77.7-16.7-29.4,25.3C3560,1291.3,3594,1294.7,3594,1294.7z"
                  />
                </defs>
              </g>
              <g>
                <path
                  className="st3"
                  d="M3524.9,1070.5c11.5,16.2,21.7,33.4,31.1,51c9.3,17.6,17.5,35.9,23.8,54.9l2.3,7.1c0.7,2.4,1.3,4.8,2,7.2
      c0.6,2.4,1.4,4.8,1.9,7.3l1.6,7.4c1.1,4.9,1.9,9.8,2.7,14.8l1.1,7.4l1,7.4c1.3,9.9,2.3,19.8,3,29.8c0.7,10,1.2,19.9,1,30.1
      l-5.2-0.2c0.3-9.8,0.1-19.7-0.4-29.6c-0.5-9.9-1.3-19.8-2.3-29.6l-0.8-7.4l-1-7.4c-0.7-4.9-1.4-9.8-2.4-14.7l-1.4-7.3
      c-0.5-2.4-1.2-4.8-1.8-7.2c-0.6-2.4-1.2-4.8-1.8-7.2l-2.2-7.1c-5.9-18.9-13.6-37.3-22.5-55.1
      C3545.9,1104.3,3536.1,1087,3524.9,1070.5z"
                />
                <path
                  className="st3"
                  d="M3592.2,1260.8c2.4-3.7,4.9-7.1,7.6-10.4c2.7-3.3,5.4-6.6,8.3-9.7c2.9-3.1,6-6.1,9.1-8.9
      c3.2-2.8,6.5-5.4,10-7.8c-3.2,2.7-6.4,5.5-9.3,8.6c-2.9,3-5.7,6.2-8.3,9.5c-2.6,3.3-5.1,6.7-7.4,10.2c-2.3,3.5-4.5,7.1-6.5,10.7
      L3592.2,1260.8z"
                />
                <path
                  className="st3"
                  d="M3590.6,1242.8c-2.6-2.2-5.4-4.3-8.2-6.4c-2.8-2-5.7-4-8.6-5.8c-3-1.8-6-3.5-9.1-5.1
      c-3.1-1.5-6.3-2.9-9.7-4c3.4,0.8,6.8,1.9,10,3.2c3.3,1.3,6.5,2.8,9.6,4.3c3.1,1.6,6.2,3.3,9.3,5.1c3,1.8,6,3.7,8.9,5.8
      L3590.6,1242.8z"
                />
                <path
                  className="st3"
                  d="M3584.5,1203.1c-3.4-3.7-7.1-7.3-10.8-10.7c-3.8-3.4-7.8-6.6-11.9-9.7c-4.1-3-8.4-5.8-12.9-8.3
      c-4.5-2.4-9.2-4.5-14.1-6.1c5,1.4,9.8,3.2,14.4,5.4c4.6,2.3,9.1,4.8,13.4,7.7c4.3,2.9,8.5,5.9,12.5,9.2c4,3.3,7.9,6.7,11.6,10.4
      L3584.5,1203.1z"
                />
              </g>
              <path
                className="st3"
                d="M3586.2,1096.6c-0.4,5.5-1.1,10.9-2,16.4c-0.8,5.4-1.9,10.8-2.9,16.2c-1.1,5.4-2.3,10.8-3.5,16.1
    c-1.2,5.4-2.5,10.7-3.9,16l-2-0.6c1.6-5.2,3-10.5,4.4-15.9c1.4-5.3,2.8-10.6,4-16c1.2-5.3,2.4-10.7,3.5-16.1
    C3584.8,1107.5,3585.7,1102.1,3586.2,1096.6z"
              />
            </g>
          </g>
          <g>
            <g>
              <g>
                <defs>
                  <path
                    id="SVGID_6_"
                    d="M3324.8,1276c64,28.1,159.1-31.2,146.6-109.2c-12.5-78-68.6-71.8-46.8-146.6
        c21.8-74.9-37.4-188.8-81.1-78c-43.7,110.8-31.8,139.5-84.2,137.3C3186,1076.3,3260.9,1247.9,3324.8,1276z"
                  />
                </defs>
              </g>
              <g>
                <g>
                  <g>
                    <path
                      className="st3"
                      d="M3390.8,934.7c-9.1,33.1-18.8,66.1-27.5,99.3c-8.8,33.2-16.8,66.7-23.5,100.5
          c-13.3,67.6-21.3,136.6-20.1,206l15.6-0.6c-3.8-67.9,1.5-136.4,12.2-204c5.4-33.8,12.1-67.5,19.6-101
          C3374.5,1001.5,3382.9,968.2,3390.8,934.7z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      className="st3"
                      d="M3333.6,1255.1c5.8-9.3,11.8-18.4,18.6-26.9c6.7-8.5,14.3-16.3,22.8-23.1c8.5-6.8,17.8-12.7,27.4-18.1
          c9.6-5.4,19.5-10.3,29.4-15.1c-10.2,4.2-20.4,8.5-30.3,13.4c-10,4.8-19.7,10.2-28.8,16.7c-9.1,6.5-17.5,14.1-24.9,22.5
          c-7.4,8.4-14.1,17.3-20.6,26.4L3333.6,1255.1z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      className="st3"
                      d="M3254.7,1100.8c8.7,6.5,17,13.6,24.5,21.4c7.5,7.8,14.2,16.4,20.1,25.4c11.8,18.1,20.8,37.8,29.8,57.6
          l7-3.4c-10.2-19.3-20.5-38.7-33.6-56.4c-6.6-8.8-13.9-17.1-21.9-24.5C3272.6,1113.4,3263.8,1106.8,3254.7,1100.8z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      className="st3"
                      d="M3333.6,994.8c5.1,8.4,9.7,17.2,14.1,26c4.4,8.8,8.5,17.8,12.5,26.7l3.5-1.7c-4.6-8.7-9.4-17.4-14.3-25.9
          C3344.4,1011.3,3339.2,1002.9,3333.6,994.8z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      className="st3"
                      d="M3348.2,1129c8-11.3,16.7-22.2,27.6-30.6c5.5-4.2,11.5-7.6,17.9-10.2c6.4-2.6,13.2-4.3,20.2-5.3
          c-7,0.6-13.9,1.8-20.6,4c-6.7,2.2-13.1,5.3-19,9.3c-11.8,7.9-21.5,18.6-30.4,29.5L3348.2,1129z"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g>
              <g>
                <defs>
                  <path
                    id="SVGID_8_"
                    d="M2998,1184.6c24.1,44.1,117.3,106.6,159.7,38.9c52.8-84.3,22.1-159-17.1-193.7
        c-43.7-38.7-65.3,71.4-115-4.1C2938.2,892.6,2928.2,1056.8,2998,1184.6z"
                  />
                </defs>
              </g>
              <g>
                <g>
                  <g>
                    <path
                      className="st3"
                      d="M3067.1,1064c6.1,19,12.3,38,17.5,57.2c5.2,19.2,9.1,38.7,11.4,58.3c2.3,19.6,3.1,39.3,2.5,59
          c-0.6,19.7-2.6,39.3-5.2,58.8l16.7,1.8c1.3-20.2,1.9-40.4,1.1-60.7c-0.8-20.2-3-40.4-6.8-60.2c-3.7-19.8-9.1-39.3-15.7-58.2
          C3082,1101,3074.4,1082.5,3067.1,1064z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      className="st3"
                      d="M3052.7,1140.5c0.8,26.9,4.4,53.9,11.2,80.2c6.8,26.3,16.7,51.9,29.3,76.1l9.9-5.6
          c-13.8-22.6-25.3-46.8-33.7-72.2C3060.9,1193.8,3055.4,1167.3,3052.7,1140.5z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      className="st3"
                      d="M3097.7,1157.4c-5.5-6.3-11.1-12.6-17.4-18.2c-6.3-5.7-13.1-10.7-20.4-14.8
          c-14.7-8.2-30.5-13.5-46.2-18.9c15.3,6.2,30.9,12.5,44.7,21.3c6.9,4.4,13.2,9.6,19,15.4c5.7,5.8,10.9,12.2,15.9,18.7
          L3097.7,1157.4z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      className="st3"
                      d="M3061.2,1190.7c-6.1-7.1-13-13.9-21.3-18.4c-8.2-4.6-17.1-7.5-25.9-10.5c8.6,3.5,17.3,6.9,25.1,11.9
          c7.8,4.9,14.1,11.7,19.7,19.1L3061.2,1190.7z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      className="st3"
                      d="M3179.1,1139.3c-8.4,4.3-15.7,10.4-22.8,16.7c-7,6.3-13.8,13-20.3,19.8c-6.5,6.9-12.7,14-18.8,21.3
          c-6,7.4-11.8,14.9-17,23.2l7.1,4c4.2-8,9.4-15.8,14.7-23.4c5.4-7.6,11-15.1,17-22.3c5.9-7.2,12.1-14.3,18.6-21
          C3164.2,1150.7,3171,1144.2,3179.1,1139.3z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      className="st3"
                      d="M3090.1,1185.4c-2.9,1.7-5.3,4.1-7.6,6.5c-2.3,2.4-4.5,5-6.7,7.6c-4.2,5.2-8.2,10.6-11.6,16.7l2.6,1.2
          c2.7-5.9,6.4-11.6,10.1-17c1.9-2.7,3.9-5.4,6.1-7.9C3085.1,1189.9,3087.3,1187.4,3090.1,1185.4z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      className="st3"
                      d="M3133,1068.1c-9.4,6.8-18.1,14.6-26.2,23c-8,8.5-15.4,17.6-21.8,27.5l3.4,2c5.7-10,12.4-19.4,19.9-28.2
          C3115.8,1083.7,3124,1075.4,3133,1068.1z"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g>
              <g>
                <defs>
                  <path
                    id="SVGID_10_"
                    d="M3124.5,1172.6c15.8,63.1,149.1,200.6,166.6,63.1c24.6-192.9-70.2-170.1-38.6-350.8
        c15.1-86.5-71.9-114-103.5,28.1C3117.5,1055.1,3108.7,1109.5,3124.5,1172.6z"
                  />
                </defs>
              </g>
              <g>
                <g>
                  <g>
                    <path
                      className="st3"
                      d="M3176.4,895.9c6.9,36.8,14.3,73.5,20.8,110.3c6.6,36.8,12.4,73.7,17,110.8c9.2,74.1,13.3,148.8,9.4,223
          l15.1,0.6c1.5-75.5-5.3-150.6-17-224.6c-5.9-37-13-73.8-20.8-110.5C3193.1,968.9,3184.5,932.5,3176.4,895.9z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      className="st3"
                      d="M3229.1,1186.7c-5.3-9.2-10.8-18.3-17-27.1c-6.2-8.7-13.1-17.1-21-24.3c-7.9-7.3-16.6-13.4-25.6-19
          c-9-5.6-18.3-10.6-27.7-15.4c9.1,5.4,18.1,11,26.7,17c8.6,6,16.8,12.6,24,20.1c14.6,14.9,24.6,33.5,34,52.2L3229.1,1186.7z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      className="st3"
                      d="M3247.1,1056.3c-12.8,19.7-22.6,41.3-32.4,62.6l7,2.8C3229.2,1099.4,3236.5,1077.2,3247.1,1056.3z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      className="st3"
                      d="M3271.1,1163.8c-7.9,14.6-16.7,28.7-24.3,43.6c-7.7,14.8-14.5,30-21.2,45.3l7,2.8
          c5.5-15.6,11.1-31.2,17.6-46.4C3256.7,1193.7,3264.3,1178.9,3271.1,1163.8z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      className="st3"
                      d="M3229,918.1c-7.9,8.8-14.9,18.6-21.1,28.8c-6.2,10.2-11.8,20.8-16.4,31.8l3.5,1.4
          c4-11.1,8.9-21.9,14.6-32.3C3215.2,937.4,3221.6,927.3,3229,918.1z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      className="st3"
                      d="M3211.8,1060.6c-7.3-11-15.7-21.4-26-29.8c-10.2-8.4-22.4-14.2-35.2-16.9c12.6,3.5,24.1,10.1,33.5,18.9
          c9.4,8.8,16.8,19.4,23.2,30.5L3211.8,1060.6z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="road">
          <g>
            <defs>
              <rect id="SVGID_12_" x="0" y="0" width="4000" height="2048" />
            </defs>

            <polygon
              className="st6"
              points="4000,1445 4000,1417.7 0,1311.8 0,1320.7 		"
            />
            <g className="st7">
              <polygon
                className="st8"
                points="-475.1,1359.6 2600.5,1585.4 2682.8,1591.4 4000,1688.1 4000,1445 300,1330.1 			"
              />
              <polygon
                className="st8"
                points="231.6,1411.4 2600.5,1585.4 3310.3,1423.8 1411.5,1366.1 			"
              />
              <g>
                <polygon
                  className="st3"
                  points="3356.6,1425 3310.3,1423.8 2600.5,1585.4 2682.8,1591.4 				"
                />
                <polygon
                  className="st3"
                  points="3839.5,1440 3812.8,1439.1 3576.3,1657 3634.9,1661.3 				"
                />
                <polygon
                  className="st3"
                  points="2817.7,1408.1 2774.6,1406.7 1754.3,1523.2 1816.4,1527.8 				"
                />
                <polygon
                  className="st3"
                  points="1079.4,1473.7 1140.1,1478.2 2303.3,1392 2252.8,1390.4 				"
                />
                <polygon
                  className="st3"
                  points="577.7,1436.9 622,1440.1 1834.8,1377.7 1794.8,1376.5 				"
                />
                <polygon
                  className="st3"
                  points="231.6,1411.4 201.4,1409.2 1400.6,1364.3 1432.5,1365.3 				"
                />
              </g>
              <polygon
                className="st8"
                points="-1096.1,1372.4 -475.1,1359.6 4000,1688.1 4000,2209.7 			"
              />
              <polygon
                className="st3"
                points="-535.7,1360.8 -475.1,1359.6 4000,1688.1 4000,1729.5 			"
              />
            </g>
          </g>
          <polygon className="st8" points="0,2048 3020.5,2048 0,1551.5 	" />
        </g>
        <g id="car2">
          <g>
            <path
              className="st9"
              d="M1675.5,1410.3c1.9,0.3,4.3,1.7-8.3,4.1c-67.8,12.8-249.9,41.9-319.3,52.5c-84.4,12.8-144.4,12.2-213.5,9.7
  c-69.1-2.5-275.6-25.7-306.8-31.3c-31.2-5.6,32.3-19.7,114.8-27.5c87.3-8.3,448.4-35.7,448.4-35.7S1664.7,1408.7,1675.5,1410.3z"
            />
            <path
              className="st10"
              d="M1623.8,1407c1.6,0.2,3.5,1.5-6.9,3.5c-55.7,10.8-205.4,35.4-262.4,44.2c-69.4,10.8-118.7,10.3-175.5,8.2
  c-56.8-2-238.1-19.7-263.8-24.4c-25.6-4.7,37.9-21.8,106-24.9c68.1-3.1,368.6-30.2,368.6-30.2S1615,1405.7,1623.8,1407z"
            />
            <g>
              <path
                className="st11"
                d="M1580.1,1350.4l-69.8,27.6l-158.2,21.5l-111.2-7.4l-179.4-14.7l57.7-121.4l456.6,27.3
    c0,0,1.4,13.4,5.2,29.5C1584.8,1328.9,1580.1,1350.4,1580.1,1350.4z"
              />
              <g>
                <ellipse
                  transform="matrix(4.538368e-02 -0.999 0.999 4.538368e-02 -165.8676 2584.2314)"
                  className="st12"
                  cx="1269.2"
                  cy="1378.9"
                  rx="75.8"
                  ry="36.5"
                />
                <polygon
                  className="st12"
                  points="1272.5,1303.2 1318.3,1304.9 1312.5,1458.2 1265.9,1454.6 				"
                />

                <ellipse
                  transform="matrix(4.553540e-02 -0.999 0.999 4.553540e-02 -124.1492 2633.1018)"
                  className="st12"
                  cx="1315.9"
                  cy="1381.5"
                  rx="76.7"
                  ry="37.9"
                />

                <ellipse
                  transform="matrix(4.531684e-02 -0.999 0.999 4.531684e-02 -121.6348 2635.9373)"
                  className="st13"
                  cx="1318.3"
                  cy="1381.6"
                  rx="58.7"
                  ry="27.9"
                />

                <ellipse
                  transform="matrix(4.519773e-02 -0.999 0.999 4.519773e-02 -120.9341 2636.729)"
                  className="st12"
                  cx="1318.9"
                  cy="1381.6"
                  rx="52.9"
                  ry="24.6"
                />
                <polygon
                  className="st13"
                  points="1324.7,1324.9 1317.7,1372.5 1343.7,1356.1 1345.2,1366.3 1318.2,1383.6 1338,1416.8 
      1334.3,1425.6 1313.8,1391.4 1303.4,1432.1 1299.1,1424.5 1309,1383.1 1291.8,1370.7 1293.8,1358.8 1310.5,1371.5 1317.5,1324 
              "
                />
                <path
                  className="st14"
                  d="M1306.1,1381.2c-0.4,9.4,2.9,17.1,7.3,17.3c4.5,0.2,8.4-7.3,8.8-16.7c0.4-9.4-2.9-17.1-7.3-17.3
      C1310.5,1364.3,1306.5,1371.8,1306.1,1381.2z"
                />
                <path
                  className="st13"
                  d="M1307.3,1381.2c-0.2,4.5,1.4,8.2,3.5,8.2c2.1,0.1,4-3.5,4.2-8c0.2-4.5-1.4-8.2-3.5-8.2
      C1309.4,1373.2,1307.5,1376.7,1307.3,1381.2z"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_14_"
                    d="M1007.1,1184.3c4.9,3,3.9,13.9,7,20.3c0,0,5.6,4.2,3.1,7.1c-1.4,1.6-3.5,2.8-5.9,2.3
        c-1.5-0.3-3.9-2.7-5.4-4.4c-7.4-1.2-15.2-3.5-18.8-4.8c-7.9-2.7-11.1-15.2-8-21.6C981.8,1177.9,999.7,1179.7,1007.1,1184.3z"
                  />
                </defs>

                <path
                  className="st15"
                  d="M1008.1,1182.3c2.2,12.3,7.6,24.9-10.6,19c-9.8-3.2-13.4-6.1-18.2-15c-3.8-7.1-4.7-17-4.7-17l-3.3,35.7
      l41.5,11.1l4.5-2.6l-3.4-6.3l0.5-5.2L1008.1,1182.3z"
                />
              </g>
              <path
                className="st12"
                d="M1578.5,1363.2l30.1-19.8c2.8-2,3.8-5.4,2.4-8.3c-0.6-1.3-1.2-2.7-1.8-4.1c-7.8-2.3-31.5,17.7-31.5,17.7
    L1578.5,1363.2z"
              />
              <g>
                <g>
                  <ellipse
                    transform="matrix(5.609515e-02 -0.9984 0.9984 5.609515e-02 -448.14 2239.4868)"
                    className="st12"
                    cx="960.4"
                    cy="1356.8"
                    rx="68.7"
                    ry="55.1"
                  />
                  <polygon
                    className="st12"
                    points="962.7,1288.1 995.8,1289.3 986,1428.6 956.8,1425.4 					"
                  />
                </g>
                <g>
                  <ellipse
                    transform="matrix(5.315317e-02 -0.9986 0.9986 5.315317e-02 -419.9731 2275.3113)"
                    className="st12"
                    cx="989.8"
                    cy="1359.1"
                    rx="69.6"
                    ry="53"
                  />

                  <ellipse
                    transform="matrix(5.157650e-02 -0.9987 0.9987 5.157650e-02 -415.4117 2281.0601)"
                    className="st13"
                    cx="993.2"
                    cy="1359.2"
                    rx="53.3"
                    ry="39.1"
                  />

                  <ellipse
                    transform="matrix(5.082248e-02 -0.9987 0.9987 5.082248e-02 -413.9489 2282.9902)"
                    className="st12"
                    cx="994.1"
                    cy="1359.3"
                    rx="48"
                    ry="34.4"
                  />
                  <polygon
                    className="st13"
                    points="1001.1,1307.9 995.2,1351.1 1028.3,1336.6 1030.6,1345.9 996.1,1361.1 1021.5,1391.6 
        1016.6,1399.5 990.1,1368.1 973.5,1404.8 967.3,1397.9 983.3,1360.6 956,1348.9 958.5,1338.1 985.1,1350 990.9,1307 					"
                  />
                  <path
                    className="st14"
                    d="M978.7,1358.7c-0.4,8.5,4.4,15.6,10.6,15.8c6.2,0.2,11.6-6.5,12-15c0.4-8.5-4.4-15.6-10.6-15.8
        C984.4,1343.5,979.1,1350.2,978.7,1358.7z"
                  />
                  <path
                    className="st13"
                    d="M982.5,1358.9c-0.2,4.1,2.1,7.4,5.1,7.5c3,0.1,5.5-3.1,5.7-7.1c0.2-4.1-2.1-7.4-5.1-7.5
        C985.2,1351.6,982.7,1354.8,982.5,1358.9z"
                  />
                </g>
              </g>
              <g>
                <path
                  className="st12"
                  d="M1496.7,1355.8c-1.4,31.6,8.7,57.7,22.5,58.2c13.8,0.5,26.1-24.7,27.5-56.4c1.4-31.6-8.7-57.7-22.5-58.2
      C1510.3,1298.9,1498.1,1324.2,1496.7,1355.8z"
                />
                <polygon
                  className="st12"
                  points="1524.1,1299.4 1555.5,1300.6 1551.1,1416.5 1519.2,1414 				"
                />
                <path
                  className="st12"
                  d="M1527.7,1357.6c-1.4,32,9.1,58.4,23.4,58.9c14.3,0.5,27.1-25,28.5-57c1.4-32-9.1-58.4-23.4-58.9
      C1541.8,1300.1,1529,1325.6,1527.7,1357.6z"
                />
                <path
                  className="st13"
                  d="M1536.2,1357.9c-1.1,24.5,6.6,44.7,17.2,45.1c10.6,0.4,20-19.2,21-43.7c1.1-24.5-6.6-44.7-17.2-45.1
      C1546.6,1313.9,1537.2,1333.4,1536.2,1357.9z"
                />
                <path
                  className="st12"
                  d="M1538.9,1358c-1,22.1,5.8,40.2,15.1,40.6c9.3,0.3,17.6-17.3,18.6-39.3c1-22.1-5.8-40.2-15.1-40.6
      C1548.1,1318.3,1539.8,1336,1538.9,1358z"
                />
                <polygon
                  className="st13"
                  points="1559.9,1315.7 1554.9,1351.8 1572.8,1339.3 1573.8,1347 1555.2,1360.1 1568.7,1385.2 
      1566.1,1391.8 1552.2,1366 1544.9,1396.8 1542,1391.1 1548.9,1359.8 1537.2,1350.4 1538.6,1341.4 1550,1351 1554.9,1315.1 				
      "
                />
                <path
                  className="st14"
                  d="M1547,1358.3c-0.3,7.1,1.9,12.9,5,13c3.1,0.1,5.8-5.6,6.1-12.6c0.3-7.1-1.9-12.9-5-13
      C1550,1345.6,1547.3,1351.2,1547,1358.3z"
                />
                <path
                  className="st13"
                  d="M1547.7,1358.3c-0.1,3.4,0.9,6.2,2.4,6.2c1.5,0.1,2.8-2.6,2.9-6c0.1-3.4-0.9-6.2-2.4-6.2
      C1549.2,1352.3,1547.9,1355,1547.7,1358.3z"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_16_"
                    d="M1580.1,1350.4l0.7-13.4c0,0,0.8-49.9-21.5-49.6c-18.3,0.2-26.9,20.6-33.5,43.2
        c-5.6,19-10,47.8-21.6,49c-25,2.6-55.2,6.2-81.1,8.8c-25.6,2.6-67.4,11.2-67.4,11.2c5.5-39.5,1.3-119.9-36.2-119.5
        c-34.7,0.4-49.6,59.1-58.9,125.9c-7.9,3.7-77.7,4.6-109.4,3.4c-33.9-1.2-195-11.8-215-14.8c-20-2.9-30.7,0.6-39.9-19.8
        c-8-17.8-11.8-49.1-6-80.9c2.8-15.7,6.7-21.8,8.5-30.7c1.4-6.5,4.4-18.6,5-20.9c5.1-18.7,28.4-22.7,91.5-34.1
        c3-0.5,8.3,0.5,11.6,0c67.2-51.6,140.2-91,198.9-96.1c57.2-5,166.4-7.6,218.1-5.3c15.6,0.7,107.6,9.1,137.5,14.6
        c4.2,0.8,9.2,4.1,11.7,7.9c2.5,3.8,25,36.4,35.6,59.6c2.6,2.6,4.9,4.5,6.5,5.8c1.6,1.3,2.3,3.2,2,5.1c-0.3,1.9-0.6,4.4-0.3,6.5
        c1.9,13.7,0.7,58.9,3,63.1c2.3,4.1,1.5,53.7-7.8,62.4C1601.7,1341.4,1583.5,1347.5,1580.1,1350.4z"
                  />
                </defs>

                <path
                  className="st16"
                  d="M970.8,1202.1c-83.4,13.2-57.9,28.7-1.6,30.8c95.2,3.4,156.1,5,224.3-2.5c33.2-3.6,93.2-19.5,93.2-19.5
      L970.8,1202.1z"
                />
                <path
                  className="st17"
                  d="M1256,1410c0,0,1.4-65.9,16.6-105.3c11.3-29.3,27-47.9,51.2-47.4c29.8,0.6,55.6,83.5,36,147
      C1353.4,1424.9,1256,1410,1256,1410z"
                />
                <path
                  className="st17"
                  d="M1509.9,1378.2c0,0,6.9-53.6,16.1-76.2c8.1-19.9,20.6-33,36.4-32.7c19.4,0.4,28.6,51.1,15.7,96.6
      C1573.8,1380.7,1509.9,1378.2,1509.9,1378.2z"
                />
                <path
                  className="st16"
                  d="M1315,1216.3l297-27.5l7.2,7.8C1505,1209,1191,1243,1191,1243S1289.7,1219.8,1315,1216.3z"
                />
              </g>
              <path
                className="st18"
                d="M1445,1359.7c-32.1,3.8-76.9,10.4-67.5,13.9c9.4,3.4,48.5-3.3,74-7.2
    C1512.2,1357.2,1540.7,1348.4,1445,1359.7z"
              />
              <path
                className="st19"
                d="M1360.7,1268.8c7.1,33.8,9.6,94.6,23,93.5c16.3-1.4,98.9-12.4,109.6-14.6s27.6-51.1,35.7-71.8
    c10.8-27.7,58.6-52.8,55.6,60.9c-0.1,4.9,22.4-7.3,25.3-19c4.1-17,0.6-49.2-0.1-59.2c-2-28.1-15.5-29-40.8-27.4
    C1539.2,1233,1356.6,1249.1,1360.7,1268.8z"
              />
              <path
                className="st19"
                d="M1264.7,1286.4c6-13.7-32.9-6.7-66.6,3.9c-7.7,2.4-14.4,17.7-18.7,32.7c-5.7,19.6-10,34.5-2.8,43
    c9.7,11.5,10.3,13.1,26.1,13.7c8.2,0.3,20.8,0.4,27-0.1c19.4-1.8,14.8-10,16.4-18.4C1247.9,1350.5,1258.7,1300.1,1264.7,1286.4z"
              />
              <path
                className="st19"
                d="M953.4,1332.3c24.5,0.4,72.5,3.8,101.3,5.6c36.7,2.2,64.9,12.7,89.7,33.9c12.4,10.7-39.8,14.9-94.8,12.5
    c-35.8-1.5-78.5-4.6-102.9-7c-24.4-2.4-52.3-2.4-45.9-15.3C906.2,1351.2,921.7,1331.7,953.4,1332.3z"
              />
              <g>
                <defs>
                  <path
                    id="SVGID_18_"
                    d="M1003.8,1208.6c70.1,3.6,230.1,5.7,283,2.3c58.8-78.9,67.8-104.3,123.4-104.6
        c-91.4-2-156.8-0.4-205.2,2.5c-14.3,0.9-35.6-0.1-56.2,7.2C1100.8,1133,1052.4,1170.6,1003.8,1208.6z"
                  />
                </defs>

                <path
                  className="st20"
                  d="M999.1,1210.8c125.3-76.6,367.6-96.2,424.8-104.7c-91.4-2-178.8-8.7-227.2-6.2
      C1124,1103.7,1068.6,1156.6,999.1,1210.8z"
                />
              </g>
              <path
                className="st12"
                d="M1516.7,1364.6c0,0-40.5,7.1-77.8,12.8c-34.9,5.3-53.4,9.3-82.4,14.8c-1.3,2.6-4.3,6.7-4.3,6.7l-0.6,2.7
    c0,0,75.2-12.2,98.5-14.4c44-4.1,56.3-4.4,59.9-7.5C1513.6,1376.7,1516.7,1364.6,1516.7,1364.6z"
              />
              <path
                className="st19"
                d="M1216.1,1246.8c0,0,346.7-40.7,400.3-44.7l0,4.4c0,0-339.9,36.7-402.9,57.2L1216.1,1246.8z"
              />
              <g>
                <polygon
                  className="st21"
                  points="1542.7,1214.5 1523,1216.9 1524.9,1212.6 1544.6,1210.2 				"
                />
                <polygon
                  className="st22"
                  points="1542.7,1213.8 1523,1216.2 1524.9,1211.9 1544.6,1209.5 				"
                />
              </g>
              <g>
                <polygon
                  className="st21"
                  points="1464.2,1224 1437.4,1227.5 1439.5,1222.5 1466.2,1219 				"
                />
                <polygon
                  className="st22"
                  points="1464.1,1223.1 1437.4,1226.7 1439.4,1221.7 1466.1,1218.2 				"
                />
              </g>
              <path
                className="st12"
                d="M1251.8,1417.4c4.8-2.5,7.5-6.1,8.7-11.3c0,0-57,1.1-69.8,0.9c-14.1-0.2-27.8-37.1-57.5-39.4
    c-33.6-2.6-213.7-13-229.6-12.9c-15.9,0.1-1.7,48,13.4,50.3c37.9,5.7,172.1,16.3,205.8,16.7
    C1156,1421.9,1251.8,1417.4,1251.8,1417.4z"
              />
              <g>
                <defs>
                  <path
                    id="SVGID_20_"
                    d="M1315,1216.3c133.7-12.3,197.6-18.8,270.8-25c7.5-0.8,7.5-6.3,4.2-13.5c-5.8-12.6-19.1-34.3-28-47.8
        c-38.6-7.2-135.9-12.1-150.4-11.4C1376.3,1120.5,1357.9,1146.2,1315,1216.3z"
                  />
                </defs>

                <path
                  className="st23"
                  d="M1313.3,1186.3c0,0,86.5-27.7,163.1-30.2c90.6-2.9,127.4,15.1,127.4,15.1s-27.3-52.2-37.4-53.9
      c-10-1.7-193.3-5.2-195.5-4C1368.6,1114.7,1313.3,1186.3,1313.3,1186.3z"
                />
              </g>
              <g>
                <path
                  className="st24"
                  d="M1440.3,1119.3l19.2,86.6l11.8,11.4c0.4,50.1,0.7,100.1-8.5,133.3c-2.1,7.7,6.6,13.8,6.6,13.8
      s-1.5,19.1-15.4,22.2"
                />
                <path
                  className="st24"
                  d="M1515,1124.7l27.5,70.1l11,13.9c0,0-2.9,33.6-4.7,43c-1.8,9.5,1.1,10.1,1.5,15.9c1,13.5-1.7,23.3-1.7,23.3
      "
                />
                <path
                  className="st24"
                  d="M1335.6,1215.2l14.7,14.9c16.7,47.1,21,118.6,22.8,131.6c1.2,8.2,4.4,14.4,4.4,14.4s1.2,18.6-12.2,23.6"
                />
                <path
                  className="st24"
                  d="M1208.4,1239.1c32.5-7.6,77.4-19,106.7-22.9"
                />
                <path
                  className="st24"
                  d="M1286.4,1210.9c5.9,4.1,6.3,9.2,6.3,9.2"
                />
                <path
                  className="st24"
                  d="M1206.4,1268.1c0,0,40.9-7.4,58.3,1.1c15.6,7.6,24.5,14.9,24.5,14.9l7,7.2"
                />
                <line
                  className="st24"
                  x1="1523.8"
                  y1="1125.3"
                  x2="1551.3"
                  y2="1193.6"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_22_"
                    d="M1355.5,1191.1c-7.7,2.8-17,14.8-22.5,21.4c0,0-9,4-5.5,7.4c1.9,1.9,5,3.3,8.7,3
        c2.4-0.2,6.3-2.5,8.7-4.3c11.4-0.6,23.6-2.4,29.2-3.4c12.3-2.2,18.3-14.4,18.6-22.2C1392.9,1187.5,1367.4,1186.8,1355.5,1191.1
        z"
                  />
                </defs>

                <path
                  className="st25"
                  d="M1352.1,1192.3c-11.5,13.5-21.6,22.8,6.8,18.1c15.3-2.5,21.1-5.3,29.5-14.5c6.6-7.3,9.2-17.9,9.2-17.9
      l1.1,38.7l-64.6,8l-6.6-3.3l5.9-6.4l-0.1-5.6L1352.1,1192.3z"
                />
              </g>
              <path
                className="st26"
                d="M1617.9,1236.5c-6.9,1.7-9-19.9-9.3-23.4c-0.4-4,8.4-4.8,8.4-4.8s0.5,8.8,0.7,14
    C1617.8,1228.1,1617.9,1236.5,1617.9,1236.5z"
              />
              <g>
                <path
                  className="st27"
                  d="M1111,1278.4c-3.3,0.1-6.5-2.5-7.8-5.3c-4.2-8.5-9.5-25.1,17.3-25.7c43.8-0.9,67.5-5.3,85.7-8.2
      c5.3-0.8,9.9,3.1,9.4,8c-0.4,4.2-1,9-1.8,12.8c-1.1,5.8-5.2,8.6-17.3,10.3C1165.1,1274.8,1125.1,1277.8,1111,1278.4z"
                />
                <path
                  className="st27"
                  d="M925.2,1266.7c0,0-27-3.6-24.7-14c1.5-6.7,3.2-14.5,7.3-18.8c0,0,4,5.9,20.6,6.8
      C926.2,1247.6,930.1,1259.4,925.2,1266.7z"
                />
                <path
                  className="st12"
                  d="M1094.5,1315.1c10.4,0.1,18.9-5.3,22.9-16.8c2.4-7,7.6-23.9,9.1-35.6c1.6-12.5-1.4-15.7-13.1-15.6
      c-96.1,0.8-161.6-2.9-187.5-6.8c-9.1-1.4-11.9,3.5-12.4,13.4c-0.4,9.9,0.9,25.4,1.4,32c0.4,6.6,1.3,20,9.2,21
      C944.2,1309.6,1005,1314.5,1094.5,1315.1z"
                />
                <path
                  className="st28"
                  d="M921.8,1249.7c0,0,30.4,4.4,74.8,6.7c58.1,3,119.8,0.6,119.8,0.6l-4.7,6.3c0,0-55.2,3-115.5-0.2
      c-40.1-2.1-73.5-8.3-73.5-8.3L921.8,1249.7z"
                />
                <path
                  className="st28"
                  d="M921,1269.2c0,0,30.4,4.4,74.8,6.7c58.1,3,119.8,0.6,119.8,0.6l-4.7,6.3c0,0-55.2,3-115.5-0.2
      c-40.1-2.1-73.5-8.3-73.5-8.3L921,1269.2z"
                />
                <path
                  className="st28"
                  d="M920.1,1288.8c0,0,30.4,4.4,74.8,6.7c58.1,3,119.8,0.6,119.8,0.6l-4.7,6.3c0,0-55.2,3-115.5-0.2
      c-40.1-2.1-73.5-8.3-73.5-8.3L920.1,1288.8z"
                />
                <path
                  className="st29"
                  d="M1003,1270.2c-0.5,4.3-3.9,7.6-7.4,7.2c-3.6-0.4-6-4.2-5.5-8.5c0.5-4.3,3.9-7.6,7.4-7.2
      C1001.1,1262,1003.5,1265.8,1003,1270.2z"
                />
              </g>
            </g>
          </g>
          <g>
            <path
              className="st9"
              d="M2280.4,1451.1c2,0.3,4.4,2-8.7,4.9c-70.1,15.3-258.6,50.1-330.4,62.7c-87.3,15.3-149.4,14.7-220.9,11.9
  c-71.5-2.8-284.9-29.6-317.1-36.2c-32.2-6.6,33.1-28.3,118.8-32.8c85.7-4.4,463.8-43.2,463.8-43.2S2269.3,1449.4,2280.4,1451.1z"
            />
            <path
              className="st10"
              d="M2202.9,1447.8c1.6,0.3,3.6,1.7-7,4c-56.9,12.4-209.9,40.7-268.2,50.9c-70.9,12.4-121.3,11.9-179.3,9.7
  c-58-2.3-243.1-22.1-269.3-27.4c-26.2-5.3,38.7-25,108.3-28.6c69.6-3.6,376.5-35.1,376.5-35.1S2193.9,1446.4,2202.9,1447.8z"
            />
            <g>
              <path
                className="st11"
                d="M2206.3,1379.9l-72,30l-158.6,14.1l-119.3,1.1l-185-16.1l59.6-132.2l453.8,29.7c0,0,18.7,14.9,22.6,32.4
    C2211.2,1356.4,2206.3,1379.9,2206.3,1379.9z"
              />
              <g>
                <path
                  className="st30"
                  d="M1848,1409.2c-1.9,45.5,13.4,83.1,34.2,83.9c20.8,0.8,39.2-35.5,41.1-81c1.9-45.5-13.4-83.1-34.2-83.9
      C1868.2,1327.4,1849.9,1363.6,1848,1409.2z"
                />
                <polygon
                  className="st30"
                  points="1889,1328.2 1936.3,1330 1930.2,1497 1882.1,1493.1 				"
                />
                <path
                  className="st30"
                  d="M1894.6,1412c-1.9,46.1,14,84.2,35.6,85c21.6,0.8,40.6-35.9,42.6-82c1.9-46.1-14-84.2-35.6-85
      C1915.6,1329.2,1896.5,1365.9,1894.6,1412z"
                />
                <path
                  className="st13"
                  d="M1907.4,1412.5c-1.5,35.3,10.2,64.4,26.1,65c15.9,0.6,30-27.5,31.5-62.8c1.5-35.3-10.2-64.4-26.1-65
      C1923,1349.1,1908.9,1377.2,1907.4,1412.5z"
                />
                <path
                  className="st30"
                  d="M1911.5,1412.7c-1.3,31.8,9,58,23,58.5c14,0.5,26.4-24.8,27.8-56.6c1.3-31.8-8.9-58-22.9-58.5
      C1925.2,1355.6,1912.8,1380.9,1911.5,1412.7z"
                />
                <polygon
                  className="st13"
                  points="1942.9,1351.9 1935.6,1403.8 1962.5,1385.9 1964,1397 1936.1,1415.8 1956.5,1452 1952.7,1461.6 
      1931.5,1424.3 1920.8,1468.6 1916.4,1460.4 1926.6,1415.3 1908.9,1401.7 1910.9,1388.8 1928.2,1402.6 1935.4,1350.9 				"
                />
                <path
                  className="st14"
                  d="M1923.7,1413.2c-0.4,10.2,3,18.6,7.6,18.8c4.6,0.2,8.7-8,9.1-18.2c0.4-10.2-3-18.6-7.6-18.8
      C1928.2,1394.8,1924.1,1402.9,1923.7,1413.2z"
                />
                <path
                  className="st13"
                  d="M1924.9,1413.2c-0.2,4.9,1.4,8.9,3.6,9c2.2,0.1,4.1-3.8,4.3-8.7c0.2-4.9-1.4-8.9-3.6-9
      C1927,1404.4,1925.1,1408.3,1924.9,1413.2z"
                />
              </g>
              <g>
                <path
                  className="st30"
                  d="M2120.3,1385.7c-1.4,34.4,8.9,62.8,23.2,63.4c14.2,0.6,26.9-26.9,28.4-61.4c1.4-34.4-8.9-62.8-23.2-63.4
      C2134.4,1323.7,2121.7,1351.2,2120.3,1385.7z"
                />
                <polygon
                  className="st30"
                  points="2148.7,1324.3 2181,1325.5 2176.4,1451.9 2143.5,1449 				"
                />
                <path
                  className="st30"
                  d="M2152.2,1387.7c-1.5,34.9,9.3,63.6,24.1,64.2c14.8,0.6,28-27.2,29.4-62.1c1.5-34.9-9.4-63.6-24.1-64.2
      C2166.9,1325,2153.7,1352.8,2152.2,1387.7z"
                />
                <path
                  className="st13"
                  d="M2161,1388c-1.1,26.7,6.8,48.7,17.7,49.1c10.9,0.4,20.6-20.9,21.8-47.6c1.1-26.7-6.8-48.7-17.7-49.1
      C2171.9,1340,2162.1,1361.3,2161,1388z"
                />
                <path
                  className="st30"
                  d="M2163.8,1388.1c-1,24,6,43.8,15.5,44.2c9.6,0.4,18.2-18.8,19.2-42.8c1-24-6-43.8-15.6-44.2
      C2173.4,1344.9,2164.8,1364.1,2163.8,1388.1z"
                />
                <polygon
                  className="st13"
                  points="2185.5,1342.1 2180.4,1381.3 2198.8,1367.7 2199.8,1376.1 2180.7,1390.4 2194.5,1417.8 
      2191.9,1425 2177.5,1396.8 2170,1430.4 2167,1424.2 2174.2,1390.1 2162.1,1379.8 2163.5,1370 2175.3,1380.5 2180.4,1341.4 				
      "
                />
                <path
                  className="st14"
                  d="M2172.1,1388.4c-0.3,7.7,2,14.1,5.1,14.2c3.2,0.1,6-6,6.3-13.8c0.3-7.7-2-14.1-5.1-14.2
      C2175.3,1374.6,2172.5,1380.7,2172.1,1388.4z"
                />
                <path
                  className="st13"
                  d="M2173,1388.5c-0.2,3.7,0.9,6.7,2.4,6.8c1.5,0.1,2.8-2.9,3-6.6c0.2-3.7-0.9-6.7-2.4-6.8
      C2174.5,1381.9,2173.1,1384.8,2173,1388.5z"
                />
              </g>
              <g>
                <ellipse
                  transform="matrix(4.297771e-02 -0.9991 0.9991 4.297771e-02 105.3807 2884.0413)"
                  className="st30"
                  cx="1558.1"
                  cy="1387"
                  rx="75.3"
                  ry="41.2"
                />
                <polygon
                  className="st30"
                  points="1561.2,1311.7 1613,1313.8 1607.6,1466.2 1554.9,1462.3 				"
                />
                <path
                  className="st30"
                  d="M1568,1388.3c-1.8,42.1,16,76.9,39.6,77.9c23.6,0.9,44.2-32.5,46-74.5c1.8-42.1-16-76.9-39.6-77.9
      C1590.3,1312.9,1569.7,1346.2,1568,1388.3z"
                />
                <path
                  className="st31"
                  d="M1582,1388.9c-1.3,32.2,11.7,58.9,29.1,59.6c17.4,0.7,32.6-24.9,34-57.1c1.3-32.2-11.7-58.9-29.1-59.6
      C1598.6,1331.1,1583.3,1356.7,1582,1388.9z"
                />
                <path
                  className="st30"
                  d="M1586.4,1389c-1.2,29,10.2,53,25.6,53.6c15.3,0.6,28.8-22.4,30-51.4c1.2-29-10.2-53-25.6-53.6
      C1601.1,1337,1587.7,1360,1586.4,1389z"
                />
                <polygon
                  className="st31"
                  points="1620.4,1333.8 1612.8,1381.1 1642.1,1365 1643.8,1375.1 1613.5,1392.1 1636,1425.3 1632,1434 
      1608.5,1399.8 1597.1,1440.2 1592.2,1432.6 1603.1,1391.6 1583.5,1379 1585.7,1367.2 1604.7,1380 1612.2,1332.8 				"
                />
                <path
                  className="st14"
                  d="M1599.8,1389.6c-0.4,9.3,3.4,17,8.4,17.2c5,0.2,9.4-7.2,9.8-16.5c0.4-9.3-3.4-17-8.4-17.2
      C1604.6,1372.8,1600.2,1380.2,1599.8,1389.6z"
                />
                <path
                  className="st13"
                  d="M1601.1,1389.6c-0.2,4.4,1.6,8.1,4,8.2c2.4,0.1,4.5-3.4,4.7-7.9c0.2-4.4-1.6-8.1-4-8.2
      C1603.4,1381.6,1601.3,1385.2,1601.1,1389.6z"
                />
              </g>
              <path
                className="st3"
                d="M2206.3,1379.9l0.8-14.6c0,0-3.7-46.1-22.7-49.7c-23.1-4.3-32.4,23.3-36.6,44.3
    c-4.2,21.1-9.7,50.9-21.7,52.2c-25.8,2.8-55.5,5.4-82.3,6.8c-26.9,1.4-68.2,5-68.2,5s4.8-7.1,6.1-21
    c1.3-13.9,11.6-93.9-41.2-100.4c-40.6-5-55.7,48.9-61.9,72.1c-6.2,23.1-14.1,46.3-22.2,50.4c-8.1,4-47.9,2.8-80.5-0.2
    c-32.7-3-237-18.6-257.6-21.9c-20.6-3.2-39.7-11-44.7-34.6c-5-23.6-12.6-55.5-5.4-66.7c7.2-11.2,33-100.4,33-100.4l-6-13.9
    c0,0,20.2-11.7,27.4-16.4c22.8-14.7,103.6-40.6,123.9-49.6c41.1-18.4,47.7-21.8,104.8-22c57-0.2,114.4,2.6,171,8.6
    c55.4,5.8,118.4,35.1,147.8,62.8c29.4,27.7,74.9,90.2,74.9,90.2s31,12.3,43.5,24c12.5,11.7,15.2,17.4,18,29.9
    C2213.9,1348.7,2212,1362.5,2206.3,1379.9z"
              />
              <path
                className="st27"
                d="M2139.2,1259.9c0,0-174.2-58.6-211.9-69.8c-36.9-11-46.4-18.2-30.2-31.7c33.2-27.4,52.1-34.6,88.8-26.3
    c29.6,6.7,62.8,21.7,83.8,41.9C2097.1,1200.3,2139.2,1259.9,2139.2,1259.9z"
              />
              <path
                className="st30"
                d="M1927.3,1190.1c37.7,11.2,211.9,69.8,211.9,69.8s-42.1-59.6-69.5-85.9c-21-20.2-54.2-35.2-83.8-41.9
    c-8.2-1.8-15.4-2.9-22.2-3.2c-23.6-0.9-40.8,8.2-66.6,29.5C1880.8,1171.8,1890.4,1179.1,1927.3,1190.1z M1901,1162.7
    c26.7-22.1,41.9-28.9,62.4-28.1c6.2,0.2,13.1,1.2,21.1,3c31.4,7.1,62.4,22.6,81,40.4c18.5,17.7,44.1,51.3,58.3,70.5
    c-45.1-15.1-164.4-55-194.7-64c-12.4-3.7-20.7-6.7-26.3-9.4c-6.7-3.3-7.3-5.3-7.3-5.5C1895.4,1169.5,1895.1,1167.6,1901,1162.7z"
              />
              <path
                className="st30"
                d="M2139.2,1259.9c0,0-174.2-58.6-211.9-69.8c-36.9-11-46.4-18.2-30.2-31.7c59.9,0,94.2,10.2,128.9,24.4
    C2111.7,1217.8,2139.2,1259.9,2139.2,1259.9z"
              />
              <path
                className="st32"
                d="M2154.9,1301.5l5.4-10.3c0,0-167.8-47.9-228.6-64.9c-62.6-17.5-88.2-29.2-145.4-33.5
    c-55-4.2-129.3-7.4-173.9-7.5c-60.7-0.2-117.3,2.1-117.3,2.1l6,13.9c0,0,58.3-3,116.3-3c58,0,176.7,4.4,214.5,11.7
    c37.6,7.2,315,84.3,315,84.3l-4.6,29.9L2154.9,1301.5z"
              />
              <g>
                <path
                  className="st33"
                  d="M1708,1229.1l-38.2-28.1c0,0,83.1,0.7,150.1,10c16.7,2.3,28.8,9.5,39.2,19.5c8.2,7.8,0.9,21.4-10.1,19
      C1792.7,1237.1,1708,1229.1,1708,1229.1z"
                />
                <path
                  className="st33"
                  d="M1583.1,1200.1l-35.6,24.9c-26.8,2.8-42.2,4.6-55.7,7.5l9.3-31.2c0,0,6.5,0.1,22.6-0.5
      C1553,1199.8,1583.1,1200.1,1583.1,1200.1z"
                />
                <path
                  className="st33"
                  d="M1708,1229.1c0,0-52.4-4.1-91.6-4.9c-36.9-0.7-68.8,0.7-68.8,0.7l35.6-24.9c0,0,15.7-0.5,38.3-0.2
      c22.6,0.2,48.3,1.2,48.3,1.2L1708,1229.1z"
                />
              </g>
              <polygon
                className="st29"
                points="1672.8,1262.7 1563.1,1258.4 1570.2,1231.4 1678.7,1233.7 			"
              />
              <path
                className="st18"
                d="M2057.6,1384.7c-32-1.2-76,3.3-67.3,8.1c8.7,4.8,59.6,5.7,84.2,6.1c24.6,0.4,71.2-1,52.4-5.2
    C2105.5,1389,2082.1,1385.7,2057.6,1384.7z"
              />
              <path
                className="st34"
                d="M1522.7,1171c0,0,44.2-1,103.9-0.9c67,0.2,129.4,1.7,174,3.9c39.4-26.8,88-69.4,121.7-66
    c0,0-86.6-9.4-135.7-9.6c-45.7-0.2-74.2,1.3-89.8,2.4C1653,1103.9,1602.2,1130.4,1522.7,1171z"
              />
              <path
                className="st27"
                d="M1522.7,1171c0,0,44.2-1,103.9-0.9c55.7,0.1,108.3,1.2,150,2.8c8.5,0.3,16.5,0.7,24,1.1
    c38.5-26.2,85.8-67.5,119.5-66.2c0.8,0,1.5,0.1,2.3,0.2c0,0-66.5-7.2-116-9.2c-7-0.3-13.7-0.4-19.8-0.5
    c-45.7-0.2-74.2,1.3-89.8,2.4C1653,1103.9,1602.2,1130.4,1522.7,1171z"
              />
              <path
                className="st35"
                d="M1708,1229.1l-30,36.8c-1.1,1.4-2.9,2.2-4.8,2.1l-110.6-4.3c-2.5-0.1-4.7-1.8-5.3-4.1l-9.7-34.7l22.6,6.5
    l107.5,2.2L1708,1229.1z"
              />
              <path
                className="st32"
                d="M1570.2,1231.4l-22.6-6.5c0,0,28-3.6,68.9-3.2c40.9,0.4,91.5,7.4,91.5,7.4l-29.3,4.6L1570.2,1231.4z"
              />
              <g>
                <path
                  className="st30"
                  d="M1856.7,1428.3c4.9-5.1,8.7-10.6,10.8-19.6c0,0-77.6-5.5-81.6-9.7c-12.7-13.6-21.5-20.5-27.8-24.7
      c-6.9-4.7-22.8-7.8-41.3-9.3c-18.6-1.4-205.5-14.9-221.9-14.8c-16.4,0.1-14.7,29.8-14.9,34.8c-0.2,5,17.3,16.1,32.9,18.9
      c43.8,7.9,178.2,18.5,212.3,21.2C1759.4,1427.9,1856.7,1428.3,1856.7,1428.3z"
                />
                <path
                  className="st30"
                  d="M2136.1,1402.9c0,0-38.1,3.1-73.6,4.3c-35.5,1.2-81.2-0.6-81.2-0.6s-3.9,12.6-4.5,14
      c-1.4,2.8-4.6,3.4-4.6,3.4l-0.5,5c0,0,66.3-7.6,90.3-9.4c54.6-4.1,64.3,0.7,67.9-2.6C2133.6,1413.6,2136.1,1402.9,2136.1,1402.9
      z"
                />
              </g>
              <g>
                <path
                  className="st36"
                  d="M1912.6,1309.6c-9-24.5-41.4-54.2-51.7-65.3"
                />
                <path
                  className="st37"
                  d="M1800.6,1174l-19.5,18.5l6.1,14.9c0,0-6,69-8.8,87.9c-2,13.5-5.5,25-27.1,24.2
      c-86.3-3.3-219.9-9.9-248-12.9c-13.5-1.4-14.1-10.4-12.7-24.7c1.3-14.3,17-81.6,17-81.6l-3.1-13.9l18.1-15.4"
                />
                <polyline
                  className="st37"
                  points="1935.6,1133.4 1929,1190.6 1939.7,1228.5 1940.8,1243.8 1960.3,1310.1 				"
                />
                <path
                  className="st37"
                  d="M2121.7,1418.1l9.4-15.5l0.4-8.8c0,0,11.7-67.5,13.7-85.4c1.7-15.7,3.1-20.8,3.1-20.8l-9.1-27.9"
                />
                <path
                  className="st37"
                  d="M2017.3,1142l33.2,88.2l7.9,31.9l-1,15.6c0,0,4.4,45.5,2.9,63.4c-1.5,17.9-4.6,44-2.6,49.9
      c2,5.8,5.1,7.5,5.1,7.5s1.4,2.6-1.7,11.1c-3.1,8.5-3.6,10.2-3.6,10.2"
                />
              </g>
              <path
                className="st18"
                d="M1501.2,1201.3l28.4-0.6c0,0-11.1,49.1-15.3,61.2c-12,34.4-33,11.6-42.3,31.4
    C1482.6,1264.1,1501.2,1201.3,1501.2,1201.3z"
              />
              <path
                className="st38"
                d="M1512.2,1299.8c1.5-13.6,17.4-99.1,17.4-99.1c89.4-1.2,153.9-1.1,257.6,6.8c0,0-7.7,84.8-12,100.5
    c-4.3,15.6-26.2,12.8-24.8,28.2c1.3,15.4,6.5,47.5,13,57.6c6.5,10.1,27.7,28.9,56.8,29.8c29.1,1,36.3,1.5,36.3,1.5l-7.3,3.2
    c-23.5-0.2-95.5-0.8-123.9-3.1c-34.2-2.8-168.5-13.3-212.3-21.2c-4.8-0.9-9.8-2.5-14.4-4.6c-15.1-9.2-15.3-53.7-14.5-73.5
    C1484.6,1311.6,1510.7,1313.4,1512.2,1299.8z"
              />
              <path
                className="st38"
                d="M1811.1,1321.1c7.3-30.4,10.7-52.4,26.4-61.3c13.7-7.7,74.7-2.6,96.4,3.1c9.9,2.5,201.3,61.8,201.3,61.8
    s-2.2,5.1-6.9,24.6c-1.9,7.9-4.1,19.7-5.6,27.9c-1,5.4-3.6,9.1-6.4,8.8l-113.9-4.3c-4.7-0.4-8.7-6-10.5-14.6
    c-2-9.6-4.3-28.7-7.3-39.3c-7.2-25.4-22.2-40.3-37.6-44.9c-29.8-8.7-62.1,3.9-88.4,56.8c-2.4,4.7-4.4,9.4-6.1,13.8
    c-2.5,6.2-11.9,43-18.1,42.6c-6.2-0.4-33.1-22-31.4-43.1C1803.8,1343.2,1806.5,1340.4,1811.1,1321.1z"
              />
              <path
                className="st39"
                d="M1610.4,1209.3c-1.2,4,0.7,8,4.3,9.1c3.6,1.1,7.5-1.3,8.8-5.3c1.2-3.9-0.7-8-4.3-9.1
    C1615.6,1203,1611.7,1205.4,1610.4,1209.3z"
              />
              <path
                className="st18"
                d="M1600.7,1306.6c-82.1-2.9-111-4-128.7-1.4c-23.1,3.4,63,11.5,126,14.3c107.1,4.8,171.6,8.6,195,1.8
    C1818.9,1314,1672.8,1309.2,1600.7,1306.6z"
              />
              <path
                className="st18"
                d="M1786.4,1192.8c-55-4.2-291.2-5.4-291.2-5.4l27.4-16.4c0,0,103.7-1.3,130.6-0.7c37,0.7,149.6,1,179.8,7.1
    c20.5,4.2,130.9,38,167.2,48.7c33.2,9.8,122.8,37.7,171.1,56.1c22.8,8.7,29.4,16.9,29.4,16.9s-30.5-14.3-40.4-7.9
    c0,0-167.8-47.9-228.6-64.9C1869.1,1208.8,1843.5,1197.1,1786.4,1192.8z"
              />
              <g>
                <polygon
                  className="st40"
                  points="1943.5,1229.7 1973.2,1238.1 1971.8,1232.2 1942.2,1223.8 				"
                />
                <polygon
                  className="st22"
                  points="1943.7,1228.7 1973.4,1237.2 1972.1,1231.3 1942.4,1222.8 				"
                />
              </g>
              <g>
                <polygon
                  className="st40"
                  points="2062.6,1263.6 2089.3,1271.2 2088.1,1265.5 2061.4,1257.9 				"
                />
                <polygon
                  className="st22"
                  points="2062.8,1262.7 2089.5,1270.3 2088.3,1264.7 2061.6,1257 				"
                />
              </g>
              <path
                className="st3"
                d="M2133,1234.8c-0.6-1.7-0.3-3.7,0.9-5.1c1.2-1.5,3-2.3,4.9-2.1c11,0.7,29.3,2.3,33.3,5.2
    c4.2,3.1,13.6,11,6.8,15.5c-6.8,4.5-32.3,6.8-32.3,6.8l-9.7,9.3c0,0-5.4,1-6.9-3.5c-1.5-4.5,8.1-12.1,8.1-12.1L2133,1234.8z"
              />
              <path
                className="st32"
                d="M2134.4,1234.2c-0.5-1.3-0.3-2.7,0.6-3.9s2.2-1.7,3.6-1.7c9.9,0.4,28.2,1.6,32.3,4.7
    c4.2,3.1,13.6,10.3,6.7,14.7c-6.8,4.5-31.1,6.8-31.1,6.8l-9.7,9.3c0,0-5.4,1-6.9-3.5c6.3-4.1,11.3-8.2,11.3-8.2L2134.4,1234.2z"
              />
              <path
                className="st30"
                d="M2143.4,1251.9l-7.4-18.2c-0.4-0.9-0.2-1.9,0.3-2.7c0.6-0.8,1.5-1.2,2.5-1.2c8.7,0.4,27.5,1.7,32.6,5.5
    c6.7,5.1,10.5,11.3-0.6,13.2C2158,1250.7,2143.4,1251.9,2143.4,1251.9z"
              />
              <path
                className="st30"
                d="M1522.7,1171c0,0,44.2-1,103.9-0.9c67,0.2,129.4,1.7,174,3.9c44.9-33.3,88.9-60.2,121.3-66.1
    C1880.9,1104,1652.7,1104.5,1522.7,1171z"
              />
            </g>
          </g>
          <g>
            <path
              className="st9"
              d="M3055.5,1460.1c2.1,0.3,4.8,2.1-9,5.8c-74.4,20-274.6,66.8-350.8,83.8c-92.8,20.8-159.2,22.8-235.9,22.8
  s-306.3-20.6-341.1-26.5c-34.8-5.9,34.9-27.3,125.7-41.5c96.2-15,494.5-67.9,494.5-67.9S3043.5,1458.6,3055.5,1460.1z"
            />
            <path
              className="st10"
              d="M3022.9,1458.3c1.8,0.2,4,1.7-7.6,4.9c-62.4,16.8-230.4,56-294.4,70.4c-77.9,17.4-133.6,19.1-197.9,19.1
  c-64.3,0-270.1-14.5-299.3-19.5c-29.2-5,41.7-30.4,118.6-37.6c76.8-7.2,415-57,415-57S3012.9,1457,3022.9,1458.3z"
            />
            <g>
              <g>
                <ellipse
                  className="st12"
                  cx="2282.6"
                  cy="1425.7"
                  rx="63"
                  ry="86"
                />
                <polygon
                  className="st12"
                  points="2281.9,1339.7 2319.7,1339.7 2315.4,1514.5 2281.9,1511.7 				"
                />
              </g>
              <g>
                <ellipse
                  className="st12"
                  cx="2316.4"
                  cy="1427.3"
                  rx="60.6"
                  ry="87.1"
                />
                <ellipse
                  className="st13"
                  cx="2320.3"
                  cy="1427.3"
                  rx="44.7"
                  ry="66.7"
                />
                <ellipse
                  className="st12"
                  cx="2321.2"
                  cy="1427.3"
                  rx="39.3"
                  ry="60"
                />
                <polygon
                  className="st13"
                  points="2326.7,1362.8 2322.1,1417.1 2359.1,1397.4 2362.2,1408.9 2323.6,1429.6 2354.1,1466.5 
      2348.9,1476.6 2317.1,1438.6 2300,1485.2 2292.6,1476.8 2308.9,1429.5 2277.2,1416 2279.6,1402.5 2310.6,1416.2 2315,1362.1 
              "
                />
                <path
                  className="st14"
                  d="M2303.6,1427.3c0,10.7,5.8,19.3,12.9,19.3c7.1,0,12.9-8.6,12.9-19.3c0-10.7-5.8-19.3-12.9-19.3
      C2309.4,1408.1,2303.6,1416.7,2303.6,1427.3z"
                />
                <path
                  className="st13"
                  d="M2308,1427.3c0,5.1,2.8,9.2,6.2,9.2c3.4,0,6.2-4.1,6.2-9.2s-2.8-9.2-6.2-9.2
      C2310.7,1418.1,2308,1422.3,2308,1427.3z"
                />
              </g>
            </g>
            <g>
              <defs>
                <path
                  id="SVGID_24_"
                  d="M2327.5,1210.6c5.7,3.6,5.2,17.2,9,25.1c0,0,6.6,5,3.9,8.8c-1.5,2.1-3.9,3.6-6.6,3.1
      c-1.8-0.3-4.6-3.2-6.4-5.3c-8.5-1.2-17.5-3.7-21.7-5.1c-9.1-3.1-13.5-21.2-10.2-29.4C2298.2,1201.1,2318.8,1205.2,2327.5,1210.6
      z"
                />
              </defs>

              <path
                className="st41"
                d="M2328.5,1208.1c3.1,15.3,9.9,30.8-11.2,24.2c-11.3-3.6-15.6-7-21.5-18c-4.7-8.7-6.2-21.1-6.2-21.1
    l-2.1,44.8l47.9,12l5-3.5l-4.2-7.7l0.3-6.5L2328.5,1208.1z"
              />
            </g>
            <path
              className="st11"
              d="M2989.9,1389.9l-78.3,37.7l-179.5,34.1l-127.3-4.3l-205.5-10.3l59.9-154.4l522.7,13.5c0,0,2.2,16.7,7.4,36.6
  C2994.2,1362.7,2989.9,1389.9,2989.9,1389.9z"
            />
            <g>
              <ellipse
                className="st12"
                cx="2641.5"
                cy="1437.6"
                rx="65.6"
                ry="94.8"
              />
              <polygon
                className="st12"
                points="2641.5,1342.8 2686.2,1342.8 2681.1,1535.5 2641.5,1532.4 			"
              />
            </g>
            <g>
              <path
                className="st12"
                d="M2894.9,1400.3c0,39.6,12.8,71.7,28.6,71.7c15.8,0,28.6-32.1,28.6-71.7s-12.8-71.7-28.6-71.7
    C2907.7,1328.6,2894.9,1360.7,2894.9,1400.3z"
              />
              <polygon
                className="st12"
                points="2923.5,1328.6 2959.4,1328.6 2960.1,1473.8 2923.5,1472.1 			"
              />
              <path
                className="st12"
                d="M2930.4,1401.2c0,40.1,13.3,72.6,29.7,72.6c16.4,0,29.7-32.5,29.7-72.6c0-40.1-13.3-72.6-29.7-72.6
    C2943.7,1328.6,2930.4,1361.1,2930.4,1401.2z"
              />
              <path
                className="st13"
                d="M2940.1,1401.2c0,30.7,9.8,55.6,21.9,55.6c12.1,0,21.9-24.9,21.9-55.6c0-30.7-9.8-55.6-21.9-55.6
    C2949.9,1345.6,2940.1,1370.5,2940.1,1401.2z"
              />
              <path
                className="st12"
                d="M2943.2,1401.2c0,27.6,8.6,50,19.3,50c10.6,0,19.3-22.4,19.3-50c0-27.6-8.6-50-19.3-50
    C2951.8,1351.2,2943.2,1373.6,2943.2,1401.2z"
              />
              <polygon
                className="st13"
                points="2965.1,1347.4 2961.2,1392.7 2981,1376.3 2982.5,1385.9 2962,1403.1 2978.6,1433.9 2976,1442.3 
    2958.8,1410.6 2952.1,1449.5 2948.4,1442.5 2954.8,1403 2940.9,1391.8 2942,1380.5 2955.6,1391.9 2959.4,1346.8 			"
              />
              <path
                className="st14"
                d="M2952.5,1401.2c0,8.9,2.8,16.1,6.3,16.1c3.5,0,6.3-7.2,6.3-16.1c0-8.9-2.8-16.1-6.3-16.1
    C2955.3,1385.1,2952.5,1392.3,2952.5,1401.2z"
              />
              <path
                className="st13"
                d="M2953.4,1401.2c0,4.2,1.4,7.7,3,7.7c1.7,0,3-3.4,3-7.7c0-4.2-1.3-7.7-3-7.7
    C2954.7,1393.6,2953.4,1397,2953.4,1401.2z"
              />
            </g>
            <g>
              <defs>
                <path
                  id="SVGID_26_"
                  d="M2989.9,1389.9l0.2-16.7c0,0-1.6-62.4-27-61c-20.9,1.1-29.7,26.9-36.1,55.5c-5.4,24-9.1,60.2-22.3,62.3
      c-28.4,4.3-62.7,10.3-92.2,14.7c-29.1,4.4-76.4,17-76.4,17c4.3-49.6-4.4-150.1-47.3-147.9c-39.6,2-53.7,76.1-61,160.1
      c-8.8,5-88.4,9.2-124.8,9.2c-38.8,0-223.3-6-246.3-8.8s-39.4-4-51-29.1c-19-41.2-17.4-79.3-13.9-94
      c6.3-26.9,13.2-75,112.1-112.1c3.3-1.2,20.5-0.3,24.2-1.1c74.2-67.6,155.6-120.1,222.3-129.2c65.1-8.8,170.5-13.2,248.7-16.5
      c52.8-2.2,104.9,26.4,149.4,79.2c15.7,12.4,27.1,20.6,27.1,20.6s20.5,87,24.2,93.6C3004.6,1294,2999.3,1380.3,2989.9,1389.9z"
                />
              </defs>

              <path
                className="st42"
                d="M2286.9,1233c-94.5,27.5-36.9,54.6,27.5,57.2c124.4,4.9,333.7-61.6,333.7-61.6L2286.9,1233z"
              />
              <path
                className="st43"
                d="M2622.8,1491.8c0,0-1.6-82.5,13.7-132.5c11.4-37.1,28.4-61.1,56.1-61.6c34.1-0.5,62.1,85.2,42.9,165.5
    C2729.2,1489.4,2622.8,1491.8,2622.8,1491.8z"
              />
              <path
                className="st43"
                d="M2911.1,1439.5c0,0,5.2-67.3,14.6-96.1c8.2-25.2,21.9-42.3,39.9-42.6c22.2-0.4,35.2,62.6,22.7,120.1
    C2984.2,1439.6,2911.1,1439.5,2911.1,1439.5z"
              />
              <path
                className="st42"
                d="M2680.6,1234.1l252.4-51.5l16.5-10.3l27.2,19c-1.9,3.6-15.5,13.5-24.3,16.1
    c-56.1,16.1-184.4,35.8-230.9,42.5c0,0,0,0,0,0h0l-10.8-10.9l-15.8,1.9l11.5,11.1C2661.9,1257.3,2609.1,1259.9,2680.6,1234.1z"
              />
            </g>
            <path
              className="st18"
              d="M2836.1,1407.6c-36.5,6.2-87.3,16.5-76.4,20.4c10.9,3.9,55.2-6.3,84.1-12.3
  C2912.7,1401.4,2944.8,1389.1,2836.1,1407.6z"
            />
            <path
              className="st12"
              d="M2618.4,1488.4c5.4-3.3,8.3-8,9.3-14.6c0,0-85.8,10.5-93.3,5.6c-24.1-15.8-57.6-46.1-115-48
  c-29.1-0.9-183.6-6.6-201.7-5.8c-18.1,0.8,0.4,60.1,17.7,62.3c43.5,5.4,197.3,12.6,235.8,11.5
  C2509.2,1498.4,2618.4,1488.4,2618.4,1488.4z"
            />
            <g>
              <polygon
                className="st21"
                points="2947.6,1220.3 2925.8,1226.5 2927.1,1220.8 2949,1214.7 			"
              />
              <polygon
                className="st22"
                points="2947.4,1219.4 2925.6,1225.5 2926.9,1219.9 2948.8,1213.8 			"
              />
            </g>
            <g>
              <polygon
                className="st21"
                points="2854.6,1243.6 2824.2,1249.2 2826.3,1242.9 2856.6,1237.2 			"
              />
              <polygon
                className="st22"
                points="2854.4,1242.5 2824.1,1248.1 2826.2,1241.8 2856.5,1236.2 			"
              />
            </g>
            <path
              className="st29"
              d="M2316.1,1310.1c-3.9,3.8-9.4,4.5-12.3,1.6c-2.9-2.9-2-8.4,1.9-12.2c3.9-3.8,9.4-4.5,12.3-1.6
  C2320.8,1300.9,2320,1306.3,2316.1,1310.1z"
            />
            <path
              className="st44"
              d="M2735.4,1297.6c9.7,41.9,15.6,117.9,30.9,115.9c18.6-2.5,112.3-20,124.4-23.2c12.1-3.3,27.1-65.8,37.2-91.4
  c9.3-23.6,41.8-75.3,62.7,48.4c2.6,15.2,3.5-31.2,2.2-47.8c-2.7-35.2-12.3-51.1-105.8-42.5
  C2852.9,1260.1,2729.7,1273.2,2735.4,1297.6z"
            />
            <path
              className="st44"
              d="M2621.8,1332.1c7.7-16.7-15.9-16.6-70.5,21.5c-33.5,23.4-72.4,48.7-53,64.5c15.7,12.7,47,30.5,69.3,29.5
  c22.3-1.1,25.6-12.7,27.9-23.1C2598.4,1411.2,2614.1,1348.8,2621.8,1332.1z"
            />
            <path
              className="st44"
              d="M2271.5,1344.4c20.7-0.6,61.3,0.5,85.7,0.9c31.1,0.5,55.3,9,77.1,27.6c11,9.3-32.9,15.4-79.4,15.5
  c-30.2,0.1-66.4-0.9-87.1-2.1c-20.7-1.2-44.2,0-39.4-12.2C2232.5,1363.9,2244.7,1345.2,2271.5,1344.4z"
            />
            <g>
              <defs>
                <path
                  id="SVGID_28_"
                  d="M2314.7,1239c80.3,1.4,273.2-3.8,333.4-10.4c37.9-60.5,79.7-127.3,151.2-136.3
      c-104.4,1.6-194.5,6.5-249.6,12.4C2495.2,1110.4,2391.4,1168.1,2314.7,1239z"
                />
              </defs>

              <path
                className="st45"
                d="M2319.6,1241.5c154.2-110.5,415-136.9,479.9-150.1c-104.4,1.6-160.9,4.6-216,9.9
    C2500.6,1109.3,2396.3,1170.6,2319.6,1241.5z"
              />
            </g>
            <path
              className="st12"
              d="M2918.2,1410.5c0,0-45.9,10.7-88.2,19.5c-39.6,8.2-60.5,14-93.3,22.3c-1.4,3.3-4.5,8.5-4.5,8.5l-0.5,3.4
  c0,0,85.3-18.6,111.7-22.4c50-7.1,64.1-8.1,68-12.1C2915.3,1425.7,2918.2,1410.5,2918.2,1410.5z"
            />
            <g>
              <g>
                <defs>
                  <path
                    id="SVGID_30_"
                    d="M2680.6,1234.1c111.6-9.9,239.9-38.1,256.5-42.9c6.7-1.9,7-5.8,9.8-17.3
        c-41.2-49.5-104.3-70.1-135.1-66.8C2726.1,1116.3,2680.6,1234.1,2680.6,1234.1z"
                  />
                </defs>

                <path
                  className="st46"
                  d="M2682.7,1227.5c0,0,60.5-74.7,149-77c69.2-1.7,115.3,19.9,115.3,19.9s-3.7-81.5-86.2-81.5
      c-82.5,0-140.7,18.7-155,45.1C2691.5,1160.4,2682.7,1227.5,2682.7,1227.5z"
                />
              </g>
            </g>
            <path
              className="st12"
              d="M2818.6,1106.7c-2.4,0-4.7,0.1-6.8,0.3c-85.8,9.2-131.2,127-131.2,127c111.6-9.9,239.9-38.1,256.5-42.9
  c6.7-1.9,7-5.8,9.8-17.3C2908.6,1127.8,2851.2,1106.7,2818.6,1106.7z M2937.5,1183.6c-0.2,0.4-0.4,0.8-2.1,1.2
  c-7.9,2.3-44.1,10.5-92.1,19.4c-39.2,7.2-96.4,16.8-152.2,22.2c5.1-11,14.6-29.6,28.3-48.6c12.4-17.2,25.8-31.3,39.7-41.8
  c17.1-12.9,35.1-20.5,53.4-22.4c1.9-0.2,3.9-0.3,6.1-0.3c16.6,0,38.2,5.7,59.1,15.6c16.9,8,41.2,22.6,62,46.6
  C2938.9,1179.3,2938.2,1182.2,2937.5,1183.6z"
            />
            <g>
              <path
                className="st47"
                d="M2818.9,1107.1l25.3,103.7l18,16.1c2.9,62.7,2.7,126.4-6.2,168.4c-2,9.7,8.2,16.9,8.2,16.9
    s-0.8,23.9-16.5,28.4"
              />
              <path
                className="st47"
                d="M2923.3,1150.4l13.9,40.7l15.3,16.1c0,0,2.2,40.3,0.6,52.2c-1.6,11.9,3.1,21,3.9,28.2
    c1.8,16.8,0.5,25.5,0.5,25.5"
              />
              <path
                className="st47"
                d="M2704,1231.7l17.6,18c21.4,58.1,29.8,147.4,32.6,163.5c1.7,10.2,5.8,17.9,5.8,17.9s2.3,23.2-12.8,30.1"
              />
              <path
                className="st47"
                d="M2576.7,1264.1c0,0,70.6-21.8,103.9-30.1"
              />
              <path
                className="st47"
                d="M2648.1,1228.6c7.1,6.6,7.7,12.1,7.7,12.1"
              />
              <path
                className="st47"
                d="M2444.3,1317.8c0,0-100.7,4.7-136.5,4.1s-84.6-5.3-84.6-5.3"
              />
              <path
                className="st47"
                d="M2569.1,1293.9c0,0,36.3-1.3,56.7,8.5c18.2,8.8,28.7,17.5,28.7,17.5l8.3,8.6"
              />
            </g>
            <g>
              <defs>
                <path
                  id="SVGID_32_"
                  d="M2725.6,1205.7c-8.7,3.9-18.7,16.9-24.6,25.5c0,0-10,5.4-6,9.5c2.3,2.3,5.9,3.9,10.1,3.4
      c2.7-0.4,7.1-3.5,9.7-5.7c13-1.3,26.9-4.1,33.2-5.6c13.9-3.3,20.2-22.7,20.1-32.4C2768.1,1193.4,2738.9,1199.8,2725.6,1205.7z"
                />
              </defs>

              <path
                className="st48"
                d="M2721.8,1205.1c-12.5,17.4-23.6,29.5,8.7,22.3c17.4-3.9,23.8-7.6,32.9-19.4c7.2-9.4,9.6-22.8,9.6-22.8
    l3.2,48.4l-73.4,12.9l-7.7-3.8l6.5-8.3l-0.4-7L2721.8,1205.1z"
              />
            </g>
            <path
              className="st3"
              d="M2444.3,1317.8c-8.5,0.4-11.6-11.1-4.1-15c9.2-4.7,20.9-9.6,35.2-13.3c27.7-7.2,75.6-19,101.2-25.4
  c7.1-1.8,12.6,6.3,8.4,12.3c-8.7,12.4-24.5,27.9-50.2,32.6C2507.7,1313.9,2470,1316.5,2444.3,1317.8z"
            />
            <path
              className="st3"
              d="M2233.8,1307.5c0.5,5.8-4.8,10.4-10.5,9.1c-7-1.5-14.3-4.8-13.4-11.9c1.6-13.2,24.7-28,24.7-28
  S2232.5,1291.7,2233.8,1307.5z"
            />
            <g>
              <defs>
                <path
                  id="SVGID_34_"
                  d="M2654.9,1352c0,0-16.9,34.2-20.6,64.6c-3.7,30.4-2.8,62-2.8,62l-3.8,9.7l-7.1,7.1l31.2,50.3l90.8-8.2
      l25.5-153.1l-58.1-48.2l-45.2-2.3L2654.9,1352z"
                />
              </defs>

              <g className="st49">
                <ellipse
                  className="st12"
                  cx="2682.5"
                  cy="1439.4"
                  rx="66.8"
                  ry="96"
                />
                <ellipse
                  className="st13"
                  cx="2686.8"
                  cy="1439.4"
                  rx="49.2"
                  ry="73.5"
                />
                <ellipse
                  className="st12"
                  cx="2687.9"
                  cy="1439.4"
                  rx="43.3"
                  ry="66.2"
                />
                <polygon
                  className="st13"
                  points="2693.9,1368.2 2688.8,1428.1 2729.7,1406.4 2733.1,1419.1 2690.5,1441.9 2724.2,1482.6 
      2718.4,1493.7 2683.3,1451.9 2664.5,1503.2 2656.3,1493.9 2674.3,1441.8 2639.4,1427 2641.9,1412 2676.1,1427.1 2681,1367.5 
              "
                />
                <ellipse
                  className="st14"
                  cx="2682.7"
                  cy="1439.4"
                  rx="14.2"
                  ry="21.3"
                />
                <path
                  className="st13"
                  d="M2673.3,1439.4c0,5.6,3,10.1,6.8,10.1c3.8,0,6.8-4.5,6.8-10.1s-3-10.1-6.8-10.1
      C2676.3,1429.3,2673.3,1433.8,2673.3,1439.4z"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="person">
          <g>
            <path
              className="st9"
              d="M600.3,1394.6c4.2-3.5,10.2-1.9,10,2.2c-0.3,4.1,17.9,8.3,22,9.9c16.4,6.6,47.2,12.4,34.2,23.2
  c-13,10.8-40.7,12.1-49.2,11.4c-8.5-0.7-30.4-0.3-22.2-11.4c8.2-11.1-5.1-11.9-4.2-19.7C591.8,1402.5,600.3,1394.6,600.3,1394.6z"
            />
            <path
              className="st50"
              d="M615.4,1403.3c2.9,5.5-10.9,7-16.4,7c-5.5,0-3.6-3.6-3.6-7c0-3.4,4.5-6.1,10-6.1
  C610.9,1397.2,613.8,1400.3,615.4,1403.3z"
            />
            <path
              className="st10"
              d="M623.2,1422.5c3,5.5-15.1,9.6-20.6,9.6c-5.5,0-3-6.2-3-9.5c0-3.4,8.1-6.1,13.6-6.1
  C618.7,1416.4,621.6,1419.5,623.2,1422.5z"
            />
            <path
              className="st51"
              d="M595.4,1389.1c0,0-0.2,4.8,0.2,7.2c0.5,2.4-1.6,6.5,2.6,8.3c4.2,1.7,7,2.2,7,2.2s11.6-0.9,10.7-3.5
  c-0.9-2.6-5.4-12.2-5.4-12.2l-5.1-3.5L595.4,1389.1z"
            />
            <g>
              <defs>
                <path
                  id="SVGID_36_"
                  d="M602.6,1403.9c0,0,6.7-8.3,8.4-8.3c1.6,0,8.2-1.7,8,0.5c-0.4,7.2,7.7,6,8.4,8.6c0.7,2.6,1.5,6.6-1,8.8
      c-2.6,2.2-6.3,2.4-6.3,4.6c0,2.2-0.2,3.7-3.3,3.9c-3,0.2-7.9,0-10,0.4c-2.1,0.4-2.1-1.3-2.3-4.8c-0.2-3.5-0.9-7-0.9-9.4
      C603.5,1405.9,602.6,1403.9,602.6,1403.9z"
                />
              </defs>

              <path
                className="st52"
                d="M619.6,1406.3c3.5-0.8,10.9,1.2,10.9,1.2s-3.5,9.9-4.2,10.3c-0.7,0.4-5.1,5.2-7.2,5.7
    c-2.1,0.4-15.4,0.7-15.4,0.7s1.6-3.5,2.8-5.7c1.2-2.2-0.9-3.7,2.8-7C613,1408.3,616.1,1407.2,619.6,1406.3z"
              />
            </g>
            <g>
              <defs>
                <path
                  id="SVGID_38_"
                  d="M577.3,1242.2c0,0-0.4,17,1.2,27.1c1.6,10.2,8.6,40.8,9.2,43.7c0.6,2.9,2.2,9,1.9,15.4
      c-0.3,6.4,0.9,31.9,3.4,40.6c0.8,2.7,2.6,5.8,1.9,9.2c-0.7,3.5-3.9,7.2-3,10.5c0.2,0.8,7,1.3,7.1,2c0.7,2.8,1.2,5.3,1.4,7
      c0.6,5.8,2.9,11.1,2.9,11.1s3.5-9.6,8.2-11.2c2.6-0.9,9.2,0.4,9.2,0.4s0.2-1.7-2.6-6.3c-2.8-4.6-3.7-8.8-3.7-12
      c0-3.2,1.2-4.4,2.8-12.8c1.6-8.4,9.9-31,10.8-37.4c0.9-6.4,3.2-25,5.7-33.1c2.5-8.1,4-26.5,5-36.4c0.9-9.9-1.9-17.4-1.9-17.4
      L577.3,1242.2z"
                />
              </defs>

              <path
                className="st53"
                d="M607.7,1237.3l-25.8,2.8c0,0-1.9,4.4-1.6,8.5c0.2,4.1,1.7,9.3,3.7,11.8c11.3,14.1,24.2,27.4,25.1,33.8
    c0.9,6.3,2.6,17,1.9,22.9c-0.7,5.9-0.2,12.4-3.6,15.9c-3.5,3.5-7.4,5.7-7,12.2c0.5,6.5,2.9,21.3,3.8,25
    c0.9,3.7,5.8,11.3,8.1,15.9c2.3,4.6,5.4,1.7,5.4,1.7l10.2-38.6c0,0,4.8-50.3,6.5-60.7c1.6-10.5-0.2-38.4-0.6-39
    c-0.5-0.7-2.1-10.9-3.7-10.9C628.5,1238.6,607.7,1237.3,607.7,1237.3z"
              />
            </g>
            <path
              className="st54"
              d="M550.9,1250.3c-0.3,0.8-4.7,8.3-5,11.6c-0.3,3.2-0.6,6.5,2.9,10.5c3.5,4,7.6,8.1,9.4,8.6
  c1.8,0.5,1.5-1.8,1.2-3.5c-0.4-2.2-1.4-7.6-1.4-7.6s2.5,4.8,5.1,3.4c1-0.5-1.2-12.8-1.8-15.7c-0.4-2.1,1.3-3.8,0.4-3.8
  C560.9,1253.8,550.9,1250.3,550.9,1250.3z"
            />
            <path
              className="st54"
              d="M662.1,1239.7c0,0,4,8.5,4.8,10.7c0.8,2.2,1.3,6,0.5,8.5c-0.8,2.5-2.9,5.7-4.3,6.5c-1.3,0.7-7.7,2.7-7.7,2.7
  s-0.8-1.7,0.8-3.2c1.6-1.5,4-4,4.5-5.7c0.5-1.7,0-5.5,0-5.5s-0.9,8.5-3.1,8.5s-1.7-8.3-1.5-10c0.3-1.7-2.4-4.2-2.9-6.5
  c-0.5-2.2-0.8-7-0.8-7L662.1,1239.7z"
            />
            <g>
              <defs>
                <path
                  id="SVGID_40_"
                  d="M545.4,1253.1c0,0,13.1,5.6,16.5,5c2.7-4.9,0.6-15.7,2.1-22.1c1.5-6.4,4.8-24.3,5.4-30.4
      c0.6-6.1,4-6.2,4-6.2s3.4,15.9,2.8,19.6c-0.6,3.8,0.6,4.5,0,8.3c-0.6,3.8-0.4,17.2-0.4,17.2s15.4-1.3,24.4-1
      c9,0.3,37.1,0.3,37.1,0.3s-1.2-6.6-0.8-17.1c0.3-8.9,1.6-32.8,2.2-37.2c3.9,6,3.3,9.2,6.1,16.8c2.8,7.6,5.6,21.6,5.6,37.6
      c0,4.2,3.1-2.4,7.3-2.6c4.4-0.2,7.3,2.8,7.3,2.8s-3.5-24.2-5.1-31.7c-1.6-7.6-5.1-17.8-6.4-25.7c-1.2-7.8-4.2-21.2-6.7-26.4
      c-2.5-5.2-0.6-14.5-11.3-17c-4.8-1.1-14.3-3.8-14.3-3.8s-9.3-2.3-15.2-1.2c-5.9,1.2-17.4,2.3-17.4,2.3s-14.5,2.8-19.2,4.9
      c-4.7,2-8.3,11.6-9.9,16.3c-4.6,13.7-9.6,39.4-9.9,45.5C549.6,1213.4,545.4,1253.1,545.4,1253.1z"
                />
              </defs>

              <rect
                x="566.8"
                y="1239.8"
                transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 1211.6344 2487.9121)"
                className="st55"
                width="78.1"
                height="8.4"
              />
              <ellipse
                className="st55"
                cx="609.6"
                cy="1133.7"
                rx="22.4"
                ry="21.5"
              />
              <path
                className="st55"
                d="M618.8,1144.2c0,0,9,41-1.2,42.7c-5.8,0.9,0.8,2.6,2,7.9c2,9,0.2,22.9-0.3,24.4c-1.8,5.3,4,12.4-4,12.4
    s-9.3,4,2.6,5.7c11.9,1.8,18.5,10.1,18.5,10.1l-4.2-100L618.8,1144.2z"
              />
            </g>
            <g>
              <defs>
                <path
                  id="SVGID_42_"
                  d="M590.2,1109.4l3.1,8.5c0,0,1.8,8.9-0.4,14.7c-1.7,4.5-5.5,7.8-5.5,7.8s13.1,11.6,23.3,10.4
      c10.2-1.2,12.6-10.6,12.6-10.6l-6.4-7.7c0,0-1.3-3.7-0.9-5.7c0.2-1.3,2.4-0.2,3.6-1.7c0.7-0.8,1.3-3.5,1.9-5.4
      c1.1-3.4,2.2-8.7,1.2-12.1c-0.6-1.8,1.2-5.9,1.2-7.3c-0.1-7.3-0.8-13.2-6.9-14.9c-4.3-1.2-12.4-1.5-17.3,0.3
      c-5.9,2.1-9.6,9.6-10.6,13.2C588,1102.5,590.2,1109.4,590.2,1109.4z"
                />
              </defs>

              <path
                className="st56"
                d="M606.7,1085.6c0,0-5.9,1.1-7.6,6.6c-1.8,5.6-1.6,10.6-1.6,10.6l-2.1,2.6c0,0,6.7,5,7.3,8.9
    c0.8,5.5-1.9,9.9,3.8,11.4l-4.5,1.4c-1.9,2.1-7.1,6.9-7.3,9c-0.5,6.9-2.5,8.8-4.9,10.5l-1.9,12.5l23.6,10.6l20.2-10.8l-3.4-21.6
    c0,0-5.5-3.2-6-3.9c-0.5-0.7-1.3-4.4-1.3-4.4s7.6-10.6,7.1-12.3c-0.5-1.7-1.3-22.8-1.6-23.8c-0.3-1-1.1-7.1-6.3-6.4
    C615,1087.3,606.7,1085.6,606.7,1085.6z"
              />
            </g>
            <path
              className="st12"
              d="M617.2,1077.7c0,0,9.3,4.5,9.6,9.9c0.4,6.8-2.5,10-12.2,9.7c-3.8-0.1-12-3-13.1-3c-1.1,0-3.7,2-3.4,5.1
  c0.1,1.1-1,12.4-1,12.4l-2.2,0.4l-2.4-5.7c0,0-6.4-2.2-0.9,8.6c-4-6-5-19.3-5-22.9c0.1-3.6,6.9-13.8,11.5-13
  c7.2,1.3,13.5-0.5,15.3,0.3C622.9,1083.7,617.2,1077.7,617.2,1077.7z"
            />
            <path
              className="st54"
              d="M588.6,1111.9c0.7,2.5,2.3,4.3,3.5,4c1.3-0.3,1.8-2.6,1.1-5.1c-0.7-2.5-2.3-4.3-3.5-4
  C588.4,1107.1,587.9,1109.4,588.6,1111.9z"
            />
            <g>
              <defs>
                <path
                  id="SVGID_44_"
                  d="M593.3,1130.8c-0.5,6-0.5,39.9,2.6,60c2.4,15.8,5.3,26.9,5.3,26.9l-6.2,28.9c-1.1,5.1-5.6,8.7-10.8,8.8
      l-15.6,0.1l5-56l-4.2,13.2l-6.1,41.9l-19.3-6.6l5.2-50.3l16-53.4l21.9-7.3L593.3,1130.8z"
                />
              </defs>

              <path
                className="st57"
                d="M604,1232.3c-0.3-10.3-6.7-11.6-13.1-4.3c-6.4,7.3-14.5,16.1-6.4-9.4c8.2-25.5-2.6-42.9-7.3-61.1
    c-4.6-18.2-7.1-21.8-7.5-11.9c-0.4,9.9-5.1,14.2-6.4,20.9c-1.3,6.6,1,23.3-5.3,26.7c-6.3,3.4-15.8,2.3-9,4.5
    c6.7,2.2,8.3,4.5,5.5,5.5s-2.8,1.7,1.5,6c4.3,4.3,8.6,51.3,8.6,51.3H595L604,1232.3z"
              />
              <path
                className="st58"
                d="M584.6,1140.2l-2.4,5.3l4,2.4l-4.4,2.6l18.3,69.9c0,0-1.1-35.1-1.4-49.3c-0.3-14.2-6.1-38.5-6.1-38.5
    L584.6,1140.2z"
              />
            </g>
            <path
              className="st12"
              d="M585.7,1137.4l-2.4,5.3l4,2.4l-4.4,2.6l18.3,69.9c0,0-1.1-35.1-1.4-49.3c-0.3-14.2-6.1-38.5-6.1-38.5
  L585.7,1137.4z"
            />
            <g>
              <defs>
                <path
                  id="SVGID_46_"
                  d="M624.1,1136.4l21.9,8.4c0,0,11.6,39.6,11.9,42.6c0.4,3,2.6,10.4,2.2,11.4c-0.4,1,6.4,41.4,6.4,41.4
      s-5.5-5.4-10.4-2.6c-4.9,2.7-6.9,5.6-6.9,5.6l-7.4-33.9l-2.8-19.7l-1.4,20.9l6,42.7l-1.6,1.4c-3.3,2.8-8.4,1.2-9.4-3.1l-7.7-33
      c0,0,6.8-72.6-7.8-85.7C620.4,1135.5,624.1,1136.4,624.1,1136.4z"
                />
              </defs>

              <path
                className="st59"
                d="M627.9,1173c6.3-11.9,15.4-31.8,16.8-20.2c1.3,11.6,6.4,19.2,7.7,25.8c1.3,6.6,4.6,10.6,2.3,15.2
    c-2.3,4.6-3.3,7.3-0.3,7c3-0.3,6.3-0.3,1.7,2.6c-4.6,3-3.3,8.6-4,14.2c-0.7,5.6,0,16.5-0.3,23.2c-0.3,6.6,0.7,10.9-2.6,15.2
    c-3.3,4.3-4.3-29.1-4.3-29.1l-5.8-31.3c0,0-2.2,7.5-3.5,15.4c-1.3,7.9-1.2,6.6-0.9,13.6c0.3,7,3.4,6.2,2.2,18
    c-1.2,11.8,0.4,29.3-4.2,16.4c-4.6-12.9-12.2-72.5-12.2-72.5L627.9,1173z"
              />
              <path
                className="st59"
                d="M627,1140l5.3,5.8l-3.1,2l4.9,4l-7.3,71c0,0-1.2-51.6-2.2-63.3c-1-11.7-5.5-22.5-5.5-22.5L627,1140z"
              />
            </g>
            <path
              className="st12"
              d="M625.2,1135.8l5.3,5.8l-3.1,2l4.9,4l-7.3,71c0,0-1.2-51.6-2.2-63.3s-5.5-22.5-5.5-22.5L625.2,1135.8z"
            />
          </g>
        </g>
        <g id="Light" className="st60"></g>
      </svg>
    </div>
  );
};
